(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fotric-buying-guide"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('fotric-fit-finder-v3')) {
  customElements.define('fotric-fit-finder-v3', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.tabs = [...this.querySelectorAll('.ffv3__tab')];
      this.panels = [...this.querySelectorAll('.ffv3__panel')];
      this.list = this.querySelector('.ffv3__tabs');
      if (!this.tabs.length || !this.list) return;
      this.list.addEventListener('click', event => {
        const tab = event.target.closest('.ffv3__tab');
        if (this.tabs.includes(tab)) this.select(tab.dataset.choice, true);
      }, {signal});
      this.list.addEventListener('keydown', event => {
        const index = this.tabs.indexOf(event.target.closest('.ffv3__tab'));
        if (index < 0) return;
        let next = index;
        const rtl = getComputedStyle(this.list).direction === 'rtl';
        if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
        else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        const tab = this.tabs[(next + this.tabs.length) % this.tabs.length];
        this.select(tab.dataset.choice, true);
        tab.focus({preventScroll:true});
      }, {signal});
      const desired = this.activeChoice || this.dataset.initial;
      const first = this.tabs.find(tab => tab.dataset.choice === desired) || this.tabs[0];
      this.select(first.dataset.choice, false);
      this.setAttribute('data-ready', '');
      this.list.hidden = false;
    }
    select(choice, animate) {
      if (!this.tabs.some(tab => tab.dataset.choice === choice)) return;
      const changed = choice !== this.activeChoice;
      this.activeChoice = choice;
      this.tabs.forEach(tab => {
        const active = tab.dataset.choice === choice;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => {
        const active = panel.dataset.panel === choice;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.dataset.choice === panel.dataset.panel).id);
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
        panel.tabIndex = active ? 0 : -1;
        panel.toggleAttribute('data-active', active);
        panel.getAnimations().forEach(animation => animation.cancel());
        if (active && changed && animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          panel.animate([{opacity:.35},{opacity:1}], {duration:160,easing:'ease-out'});
        }
      });
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.panels?.forEach(panel => panel.getAnimations().forEach(animation => animation.cancel()));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fotric-collection-faq"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('fotric-collection-faq-v2')) {
    customElements.define('fotric-collection-faq-v2', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = {signal:this.controller.signal};
        this.groups = Array.from(this.querySelectorAll('[data-faq-group]'));
        this.buttons = Array.from(this.querySelectorAll('[data-faq-category]'));
        const controls = this.querySelector('[data-faq-controls]');
        if (controls && this.groups.length > 1) {
          controls.hidden = false;
          this.setAttribute('data-filtered','');
          this.select(this.groups[0].dataset.faqGroup);
        }
        this.addEventListener('click',event => {
          const button = event.target.closest('[data-faq-category]');
          if (button && this.contains(button)) this.select(button.dataset.faqCategory);
        },options);
        this.addEventListener('shopify:block:select',event => {
          const item = event.target.closest('.ftfaq__item');
          if (!item || !this.contains(item)) return;
          const group = item.closest('[data-faq-group]');
          if (group) this.select(group.dataset.faqGroup);
          item.open = true;
        },options);
        this.addEventListener('toggle',event => {
          const item = event.target;
          if (!item.matches('.ftfaq__item') || !item.open) return;
          this.querySelectorAll('.ftfaq__item[open]').forEach(other => {if(other !== item) other.open = false;});
        },{...options,capture:true});
      }
      select(category) {
        if (!this.groups.some(group => group.dataset.faqGroup === category)) return;
        this.groups.forEach(group => {
          group.hidden = group.dataset.faqGroup !== category;
          if (group.hidden) group.querySelectorAll('details[open]').forEach(item => {item.open=false;});
        });
        this.buttons.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.faqCategory === category)));
      }
      disconnectedCallback() { this.controller?.abort(); this.controller=null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fotric-home-reviews"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('fotric-home-reviews')) {
    const metadataRequests = new Map();
    const fetchMetadata = videoId => {
      if (metadataRequests.has(videoId)) return metadataRequests.get(videoId);
      const abort = new AbortController();
      const timer = setTimeout(() => abort.abort(), 8000);
      const url = 'https://www.youtube.com/oembed?url=' + encodeURIComponent('https://www.youtube.com/watch?v=' + videoId) + '&format=json';
      const request = fetch(url, { signal: abort.signal, credentials: 'omit' })
        .then(response => { if (!response.ok) throw new Error('Metadata unavailable'); return response.json(); })
        .then(data => ({ title: typeof data.title === 'string' ? data.title.trim() : '', creator: typeof data.author_name === 'string' ? data.author_name.trim() : '' }))
        .catch(() => null).finally(() => clearTimeout(timer));
      metadataRequests.set(videoId, request);
      return request;
    };
    let youtubePromise;
    const loadYouTube = () => {
      if (window.YT?.Player) return Promise.resolve(window.YT);
      if (youtubePromise) return youtubePromise;
      youtubePromise = new Promise((resolve, reject) => {
        const previous = window.onYouTubeIframeAPIReady;
        const timer = setTimeout(() => reject(new Error('YouTube API timeout')), 15000);
        window.onYouTubeIframeAPIReady = () => {
          clearTimeout(timer);
          resolve(window.YT);
          if (typeof previous === 'function') previous();
        };
        let script = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
        if (!script) {
          script = document.createElement('script');
          script.src = 'https://www.youtube.com/iframe_api';
          script.async = true;
          document.head.append(script);
        }
        script.addEventListener('error', () => {
          clearTimeout(timer);
          script.remove();
          reject(new Error('YouTube API unavailable'));
        }, { once: true });
      }).catch(error => { youtubePromise = null; throw error; });
      return youtubePromise;
    };
    customElements.define('fotric-home-reviews', class extends HTMLElement {
      async connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        if (!await this.loadSource(signal) || signal.aborted) return;
        this.cards = Array.from(this.querySelectorAll('[data-fvh-grid] [data-fvh-card]'));
        this.category = 'all';
        this.model = '';
        this.mediaQuery = matchMedia('(max-width: 749px)');
        this.page = 1;
        this.modelSelect = this.querySelector('[data-fvh-model]');
        this.dialog = this.querySelector('[data-fvh-dialog]');
        this.detail = this.querySelector('[data-fvh-dialog-detail]');
        this.player = this.querySelector('[data-fvh-player]');
        this.querySelector('[data-fvh-filters]')?.removeAttribute('hidden');
        this.querySelectorAll('[data-fvh-thumbnail]').forEach(image => {
          const fallback = () => {
            if (!image.dataset.fvhFallback) return;
            const url = image.dataset.fvhFallback;
            delete image.dataset.fvhFallback;
            image.src = url;
          };
          image.addEventListener('error', fallback, { signal });
          image.addEventListener('load', () => { if (image.naturalWidth <= 120) fallback(); }, { signal });
          if (image.complete && image.naturalWidth <= 120) fallback();
        });
        this.updateModels();
        this.applyFilters();
        this.refreshMetadata();
        this.addEventListener('click', event => this.handleClick(event), { signal });
        this.addEventListener('change', event => {
          if (event.target.matches('[data-fvh-model]')) {
            this.model = event.target.value;
            this.page = 1;
            this.applyFilters();
          }
        }, { signal });
        this.dialog.addEventListener('close', () => this.cleanPlayer(), { signal });
        this.mediaQuery.addEventListener('change', () => {
          this.page = 1;
          this.applyFilters();
        }, { signal });
        this.track = this.querySelector('[data-fvh-grid]');
        this.track.addEventListener('scroll', () => this.updateArrows(), { signal, passive: true });
        this.querySelectorAll('[data-home-direction]').forEach(button => button.addEventListener('click', () => this.moveTrack(Number(button.dataset.homeDirection)), { signal }));
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.moveTrack(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this.track);
        this.updateArrows();
      }
      disconnectedCallback() {
        this.dialog?.close();
        this.cleanPlayer();
        this.resizeObserver?.disconnect();
        this.controller?.abort();
        this.controller = null;
        this.metadataRunning = false;
      }
      matchesCurrentProduct(card) {
        if (!this.dataset.productHandle) return true;
        const links = card.querySelectorAll('.fvh-featured-actions a:not([data-fvh-open]), .fvh-actions a:not([data-fvh-open]), .fvh-card-body .fvh-product-cta a');
        return Array.from(links).some(link => {
          try {
            const url = new URL(link.getAttribute('href'), location.origin);
            if (url.origin !== location.origin) return false;
            const match = url.pathname.match(/\/products\/([^/]+)\/?$/);
            return !!match && decodeURIComponent(match[1]) === this.dataset.productHandle;
          } catch (_) { return false; }
        });
      }
      async loadSource(signal) {
        const status = this.querySelector('[data-home-status]');
        this.hidden = false;
        if (!this.dataset.sourceUrl) return false;
        const abort = new AbortController();
        const stop = () => abort.abort();
        signal.addEventListener('abort', stop, { once: true });
        const timer = setTimeout(stop, 12000);
        try {
          const url = new URL(this.dataset.sourceUrl, location.origin);
          if (url.origin !== location.origin) throw new Error('Same-store page required');
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url.href, { signal: abort.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Page unavailable');
          const html = await response.text();
          if (signal.aborted) return false;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const hub = parsed.querySelector('fotric-video-hub');
          const originals = Array.from(hub?.querySelectorAll('[data-fvh-card]') || []);
          if (!originals.length) throw new Error('Video hub not found');
          const unique = new Set();
          const cards = originals.filter(card => {
            if (!this.matchesCurrentProduct(card)) return false;
            const id = card.dataset.video;
            if (!/^[a-zA-Z0-9_-]{11}$/.test(id) || unique.has(id) || !card.querySelector('[data-fvh-detail]')) return false;
            unique.add(id);
            return true;
          }).map(original => {
            const card = document.importNode(original, true);
            card.hidden = false;
            card.removeAttribute('data-shopify-editor-block');
            card.classList.remove('fvh-featured');
            card.querySelector('.fvh-featured-label')?.remove();
            const heading = card.querySelector('.fvh-title');
            if (heading?.tagName === 'H2') {
              const h3 = document.createElement('h3');
              h3.className = heading.className;
              h3.append(...heading.childNodes);
              heading.replaceWith(h3);
            }
            const actions = card.querySelector('.fvh-featured-actions, .fvh-actions');
            if (actions) {
              actions.className = 'fvh-actions';
              actions.querySelector('a:not([data-fvh-open])')?.classList.add('fvh-product-link');
              if (!actions.querySelector('[data-fvh-open]')) {
                const watch = document.createElement('a');
                watch.className = 'fvh-button fvh-watch-button';
                watch.dataset.fvhOpen = '';
                watch.href = 'https://www.youtube.com/watch?v=' + card.dataset.video;
                watch.textContent = this.dataset.watchButton;
                actions.prepend(watch);
              }
            }
            if (this.dataset.productHandle) {
              actions?.querySelectorAll('a:not([data-fvh-open])').forEach(link => link.remove());
            }
            card.querySelectorAll('img').forEach(image => { image.loading = 'lazy'; image.decoding = 'async'; });
            return card;
          });
          if (!cards.length) {
            this.querySelector('[data-fvh-grid]').replaceChildren();
            this.querySelector('[data-fvh-grid]').removeAttribute('aria-busy');
            if (this.dataset.productHandle && this.dataset.designMode !== 'true') this.hidden = true;
            else status.textContent = this.dataset.noProductReviews;
            return false;
          }
          if (this.dataset.productHandle) {
            this.querySelectorAll('[data-fvh-category]').forEach(button => {
              const category = button.dataset.fvhCategory;
              button.hidden = category !== 'all' && !cards.some(card => card.dataset.categories.trim().split(/\s+/).includes(category));
            });
          }
          this.querySelector('[data-fvh-grid]').replaceChildren(...cards);
          status.hidden = true;
          this.querySelector('[data-fvh-grid]').removeAttribute('aria-busy');
          return true;
        } catch (_) {
          if (!signal.aborted) {
            status.textContent = this.dataset.loadError;
            status.hidden = false;
            this.querySelector('[data-fvh-grid]').removeAttribute('aria-busy');
          }
          return false;
        } finally {
          clearTimeout(timer);
          signal.removeEventListener('abort', stop);
        }
      }
      refreshMetadata() {
        if (!this.controller || this.metadataRunning) return;
        const lifecycle = this.controller;
        const candidates = Array.from(this.querySelectorAll('[data-fvh-card]')).filter(card => !card.hidden && !card.dataset.metadataRequested && (card.dataset.autoTitle === 'true' || card.dataset.autoCreator === 'true'));
        if (!candidates.length) return;
        this.metadataRunning = true;
        candidates.forEach(card => { card.dataset.metadataRequested = 'true'; });
        const queue = candidates.slice();
        const worker = async () => {
          while (queue.length && !lifecycle.signal.aborted) {
            const card = queue.shift();
            if (!/^[a-zA-Z0-9_-]{11}$/.test(card.dataset.video)) continue;
            const data = await fetchMetadata(card.dataset.video);
            if (lifecycle.signal.aborted) return;
            if (data) this.applyMetadata(card, data);
          }
        };
        Promise.all([worker(), worker(), worker()]).finally(() => {
          if (this.controller !== lifecycle) return;
          this.metadataRunning = false;
          this.refreshMetadata();
        });
      }
      applyMetadata(card, data) {
        if (card.dataset.autoTitle === 'true' && data.title) card.dataset.reviewTitle = data.title;
        if (card.dataset.autoCreator === 'true' && data.creator) card.dataset.reviewCreator = data.creator;
        const title = card.dataset.reviewTitle;
        const creator = card.dataset.reviewCreator;
        const update = root => {
          if (title) root.querySelectorAll('[data-fvh-title]').forEach(node => { node.textContent = title; });
          if (creator) {
            root.querySelectorAll('[data-fvh-creator]').forEach(node => { node.textContent = creator; });
            root.querySelectorAll('[data-fvh-creator-row], [data-fvh-creator-container]').forEach(node => { node.hidden = false; });
            root.querySelectorAll('[data-fvh-avatar]').forEach(node => { node.textContent = creator.slice(0, 1).toUpperCase(); node.hidden = false; });
          }
          root.querySelectorAll('[data-fvh-dialog-meta]').forEach(node => {
            node.textContent = [creator, node.dataset.extraMeta].filter(Boolean).join(' · ');
            node.hidden = !node.textContent;
          });
        };
        update(card);
        update(card.querySelector('[data-fvh-detail]').content);
        if (title) {
          card.querySelector('.fvh-media').setAttribute('aria-label', this.dataset.watchLabel.replace('[title]', title));
          card.querySelector('.fvh-cover')?.setAttribute('alt', title);
        }
        if (this.activeCard === card && this.dialog.open) {
          update(this.detail);
          this.videoTitle = title;
          this.player.querySelector('iframe')?.setAttribute('title', title);
        }
      }
      batchSize() {
        return Number(this.mediaQuery.matches ? this.dataset.mobileCount : this.dataset.desktopCount) || 4;
      }
      inCategory(card) {
        return this.category === 'all' || card.dataset.categories.trim().split(/\s+/).includes(this.category);
      }
      updateModels() {
        if (!this.modelSelect) return;
        const models = [...new Set(this.cards.filter(card => this.inCategory(card)).map(card => card.dataset.model).filter(Boolean))];
        while (this.modelSelect.options.length > 1) this.modelSelect.remove(1);
        models.forEach(model => this.modelSelect.add(new Option(model, model)));
        if (!models.includes(this.model)) this.model = '';
        this.modelSelect.value = this.model;
        const buttons = this.querySelector('[data-fvh-model-buttons]');
        if (buttons) {
          buttons.replaceChildren();
          [['', this.modelSelect.options[0].textContent], ...models.map(model => [model, model])].forEach(([value, label]) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.dataset.fvhModelButton = value;
            button.textContent = label;
            button.setAttribute('aria-pressed', String(value === this.model));
            buttons.append(button);
          });
        }
      }
      applyFilters() {
        const matches = this.cards.filter(card => this.inCategory(card));
        this.cards.forEach(card => { card.hidden = !matches.includes(card); });
        this.querySelectorAll('[data-fvh-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fvhCategory === this.category)));
        this.querySelector('[data-fvh-empty]').hidden = matches.length !== 0;
        const track = this.querySelector('[data-fvh-grid]');
        track.hidden = matches.length === 0;
        track.scrollLeft = 0;
        this.refreshMetadata();
        this.updateArrows();
      }
      moveTrack(direction) {
        const track = this.querySelector('[data-fvh-grid]');
        const card = this.cards.find(item => !item.hidden);
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      updateArrows() {
        const track = this.querySelector('[data-fvh-grid]');
        const visible = this.cards.filter(card => !card.hidden);
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        this.querySelector('[data-home-direction="-1"]').disabled = track.scrollLeft <= 2;
        this.querySelector('[data-home-direction="1"]').disabled = track.scrollLeft >= max - 2;
        this.querySelector('[data-home-controls]').hidden = visible.length === 0;

      }
      resetFilters() {
        this.category = 'all';
        this.model = '';
        this.page = 1;
        this.updateModels();
        this.applyFilters();
      }
      handleClick(event) {
        const target = event.target.closest('button, a');
        if (target?.hasAttribute('data-fvh-open')) {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const card = target.closest('[data-fvh-card]');
          if (!/^[a-zA-Z0-9_-]{11}$/.test(card.dataset.video) || !this.dialog.showModal) return;
          event.preventDefault();
          this.openVideo(card, target);
        } else if (target?.hasAttribute('data-fvh-model-button')) {
          this.model = target.dataset.fvhModelButton;
          this.modelSelect.value = this.model;
          this.page = 1;
          this.applyFilters();
        } else if (target?.hasAttribute('data-fvh-category')) {
          this.category = target.dataset.fvhCategory;
          this.page = 1;
          this.updateModels();
          this.applyFilters();
        } else if (target?.hasAttribute('data-fvh-reset')) {
          this.resetFilters();
        } else if (target?.hasAttribute('data-fvh-page')) {
          if (target.disabled) return;
          const nextPage = Number(target.dataset.fvhPage);
          if (!Number.isInteger(nextPage) || nextPage === this.page) return;
          this.page = nextPage;
          this.applyFilters();
          const heading = this.querySelector('.fvh-library-heading');
          heading?.focus({ preventScroll: true });
          heading?.scrollIntoView({ block: 'start', behavior: 'auto' });
        } else if (target?.hasAttribute('data-fvh-close')) {
          this.dialog.close();
        } else if (target?.hasAttribute('data-fvh-seek')) {
          this.seekPlayer(Number(target.dataset.fvhSeek));
          this.detail.querySelectorAll('[data-fvh-seek]').forEach(button => button.setAttribute('aria-pressed', String(button === target)));
          if (matchMedia('(max-width: 899px)').matches) this.dialog.scrollTo({ top: 0, behavior: 'auto' });
        }
        if (event.target === this.dialog) {
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }
      }
      openVideo(card, trigger) {
        this.trigger = trigger;
        this.activeCard = card;
        this.videoId = card.dataset.video;
        this.videoTitle = card.querySelector('.fvh-title').textContent.trim();
        this.detail.replaceChildren(card.querySelector('[data-fvh-detail]').content.cloneNode(true));
        this.detail.querySelector('[data-fvh-dialog-title]').id = 'FvhDialogTitle-' + this.dataset.sectionId;
        this.loadPlayer(0);
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.bodyLocked = true;
        this.dialog.showModal();
        this.dialog.scrollTop = 0;
      }
      loadPlayer(seconds) {
        const generation = this.playerGeneration = (this.playerGeneration || 0) + 1;
        this.playerReady = false;
        this.playerFailed = false;
        this.pendingSeek = null;
        this.playerStatus = this.querySelector('[data-fvh-player-status]');
        this.playerStatus.textContent = '';
        const iframe = document.createElement('iframe');
        iframe.id = 'FvhPlayer-' + this.dataset.sectionId;
        iframe.title = this.videoTitle;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        const params = new URLSearchParams({ autoplay: '1', rel: '0', playsinline: '1', enablejsapi: '1', origin: location.origin, start: String(Math.max(0, Math.floor(seconds || 0))) });
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + this.videoId + '?' + params;
        this.player.replaceChildren(iframe);
        loadYouTube().then(YT => {
          if (this.playerGeneration !== generation || !this.isConnected || !this.dialog.open) return;
          this.youtube = new YT.Player(iframe, { events: {
            onReady: event => {
              if (this.playerGeneration !== generation) return;
              this.playerReady = true;
              this.playerStatus.textContent = '';
              if (this.pendingSeek !== null) {
                event.target.seekTo(this.pendingSeek, true);
                this.pendingSeek = null;
              }
              event.target.playVideo();
            },
            onStateChange: event => {
              if (this.playerGeneration === generation && event.data === 1) this.playerStatus.textContent = '';
            },
            onAutoplayBlocked: () => {
              if (this.playerGeneration === generation) this.playerStatus.textContent = this.dataset.playBlocked;
            },
            onError: () => {
              if (this.playerGeneration === generation) {
                this.playerFailed = true;
                this.playerStatus.textContent = this.dataset.playerError;
              }
            }
          }});
        }).catch(() => {
          if (this.playerGeneration === generation) {
            this.playerFailed = true;
            this.playerStatus.textContent = this.dataset.playerError;
          }
        });
      }
      seekPlayer(seconds) {
        const time = Math.max(0, Math.floor(Number(seconds) || 0));
        const fallback = this.detail.querySelector('.fvh-youtube-link');
        if (fallback) fallback.href = 'https://www.youtube.com/watch?v=' + this.videoId + '&t=' + time + 's';
        if (this.playerFailed) {
          this.playerStatus.textContent = this.dataset.playerError;
        } else if (this.playerReady && this.youtube) {
          this.youtube.seekTo(time, true);
          this.youtube.playVideo();
          this.playerStatus.textContent = '';
        } else {
          this.pendingSeek = time;
          this.playerStatus.textContent = this.dataset.playerLoading;
        }
      }
      cleanPlayer() {
        this.playerGeneration = (this.playerGeneration || 0) + 1;
        this.playerReady = false;
        this.pendingSeek = null;
        try { this.youtube?.destroy(); } catch (_) {}
        this.youtube = null;
        this.player?.replaceChildren();
        if (this.bodyLocked) {
          document.body.style.overflow = this.previousOverflow;
          this.bodyLocked = false;
        }
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
        this.trigger = null;
        this.activeCard = null;
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fotric-layered-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeBanner = (banner) => {
      if (banner.dataset.initialized === 'true') return;
      banner.dataset.initialized = 'true';

      const slides = Array.from(banner.querySelectorAll('[data-fotric-slide]'));
      const dots = Array.from(banner.querySelectorAll('[data-flb-dot]'));
      const fills = Array.from(banner.querySelectorAll('[data-flb-dot] span'));
      const prev = banner.querySelector('[data-flb-prev]');
      const next = banner.querySelector('[data-flb-next]');
      const status = banner.querySelector('[data-flb-status]');
      const viewport = banner.querySelector('[data-flb-viewport]');
      const sectionRoot = banner.closest('.shopify-section') || banner.parentElement;
      const videoDialog = sectionRoot?.querySelector('[data-flb-video-dialog]');
      const videoFrame = videoDialog?.querySelector('[data-flb-video-frame]');
      const videoClose = videoDialog?.querySelector('[data-flb-video-close]');
      const videoOpeners = Array.from(banner.querySelectorAll('[data-flb-video-open]'));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const requestedAutoplay = banner.dataset.autoplay === 'true';
      const speed = Math.max(4000, Number(banner.dataset.speed) || 6000);
      let current = 0;
      let timer = null;
      let progressAnimation = null;
      let touchX = 0;
      let touchY = 0;

      if (!slides.length) return;

      const clearTimer = () => {
        window.clearTimeout(timer);
        timer = null;
        progressAnimation?.cancel();
        progressAnimation = null;
      };

      const render = () => {
        slides.forEach((slide, index) => {
          const active = index === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.toggleAttribute('inert', !active);
        });

        dots.forEach((dot, index) => {
          const active = index === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
      };

      const startTimer = () => {
        clearTimer();
        fills.forEach((fill) => { fill.style.transform = 'scaleX(0)'; });

        if (!requestedAutoplay || reducedMotion.matches || slides.length < 2 || document.hidden || videoDialog?.open || banner.contains(document.activeElement)) return;

        const activeFill = fills[current];
        if (activeFill) {
          progressAnimation = activeFill.animate(
            [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
            { duration: speed, easing: 'linear', fill: 'forwards' }
          );
        }

        timer = window.setTimeout(() => goTo(current + 1, false), speed);
      };

      const goTo = (index, announce = true) => {
        current = (index + slides.length) % slides.length;
        render();
        if (announce && status) status.textContent = `Slide ${current + 1} of ${slides.length}`;
        startTimer();
      };

      const getEmbeddableVideoUrl = (source) => {
        if (!source) return '';

        try {
          const url = new URL(source, window.location.origin);
          const hostname = url.hostname.replace(/^www\./, '').toLowerCase();
          let videoId = '';

          if (hostname === 'youtu.be') {
            videoId = url.pathname.split('/').filter(Boolean)[0] || '';
          } else if (hostname === 'youtube.com' || hostname === 'm.youtube.com' || hostname === 'youtube-nocookie.com') {
            const pathParts = url.pathname.split('/').filter(Boolean);
            if (pathParts[0] === 'embed' || pathParts[0] === 'shorts' || pathParts[0] === 'live') {
              videoId = pathParts[1] || '';
            } else {
              videoId = url.searchParams.get('v') || '';
            }
          }

          if (videoId) {
            return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0&playsinline=1`;
          }

          if (hostname === 'vimeo.com' || hostname === 'player.vimeo.com') {
            const vimeoId = url.pathname.split('/').filter(Boolean).find((part) => /^\d+$/.test(part));
            if (vimeoId) return `https://player.vimeo.com/video/${vimeoId}?autoplay=1`;
          }

          return '';
        } catch (error) {
          return '';
        }
      };

      prev?.addEventListener('click', () => goTo(current - 1));
      next?.addEventListener('click', () => goTo(current + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.flbDot))));

      videoOpeners.forEach((opener) => {
        opener.addEventListener('click', () => {
          const source = getEmbeddableVideoUrl(opener.dataset.videoSrc);
          if (!source || !videoDialog || !videoFrame) return;
          clearTimer();
          videoFrame.src = source;
          videoDialog.showModal();
        });
      });

      videoClose?.addEventListener('click', () => videoDialog.close());
      videoDialog?.addEventListener('click', (event) => {
        if (event.target === videoDialog) videoDialog.close();
      });
      videoDialog?.addEventListener('close', () => {
        if (videoFrame) videoFrame.src = '';
        startTimer();
      });

      banner.addEventListener('focusin', clearTimer);
      banner.addEventListener('focusout', (event) => {
        if (!banner.contains(event.relatedTarget)) startTimer();
      });

      banner.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') goTo(current - 1);
        if (event.key === 'ArrowRight') goTo(current + 1);
      });

      viewport?.addEventListener('touchstart', (event) => {
        touchX = event.touches[0].clientX;
        touchY = event.touches[0].clientY;
      }, { passive: true });

      viewport?.addEventListener('touchend', (event) => {
        const deltaX = event.changedTouches[0].clientX - touchX;
        const deltaY = event.changedTouches[0].clientY - touchY;
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 44) goTo(current + (deltaX > 0 ? -1 : 1));
      }, { passive: true });

      document.addEventListener('visibilitychange', startTimer);
      reducedMotion.addEventListener('change', startTimer);

      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          const selectedSlide = event.target.closest('[data-fotric-slide]');
          if (selectedSlide && banner.contains(selectedSlide)) {
            goTo(Number(selectedSlide.dataset.slideIndex), false);
            clearTimer();
          }
        });
      }

      const headerElement = document.querySelector('sticky-header') || document.querySelector('.header-wrapper') || document.querySelector('header');
      const headerRoot = headerElement?.closest('.shopify-section') || headerElement;

      Array.from(document.documentElement.classList).forEach((className) => {
        if (className.startsWith('flb-header-enabled-')) document.documentElement.classList.remove(className);
      });

      if (headerRoot) {
        Array.from(headerRoot.classList).forEach((className) => {
          if (className.startsWith('flb-transparent-header-')) headerRoot.classList.remove(className);
        });
        headerRoot.classList.remove('flb-header-use-light', 'is-flb-scrolled');
        headerRoot.style.removeProperty('--flb-header-top');
      }

      if (banner.dataset.transparentHeader === 'true') {

        if (headerRoot && !headerRoot.contains(banner)) {
          const rootClass = banner.dataset.headerRootClass;
          const documentClass = banner.dataset.documentClass;
          const initialTop = Math.max(0, headerRoot.getBoundingClientRect().top + window.scrollY);
          const threshold = initialTop + 24;

          document.documentElement.classList.add(documentClass);
          headerRoot.classList.add(rootClass);
          headerRoot.classList.toggle('flb-header-use-light', banner.dataset.lightHeader === 'true');
          headerRoot.style.setProperty('--flb-header-top', `${initialTop}px`);

          const updateHeader = () => {
            headerRoot.classList.toggle('is-flb-scrolled', window.scrollY > threshold);
          };

          updateHeader();
          window.addEventListener('scroll', updateHeader, { passive: true });
        }
      }

      render();
      startTimer();
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-fotric-layered-banner]').forEach(initializeBanner);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fotric-product-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fotric-model-compare')) {
    customElements.define('fotric-model-compare',class extends HTMLElement {
      connectedCallback() {
        if(this.controller)return;
        this.controller=new AbortController();
        const signal=this.controller.signal;
        this.scroller=this.querySelector('.fmc__scroll');
        this.querySelector('.fmc__arrows').hidden=false;
        const update=()=>{
          const max=this.scroller.scrollWidth-this.scroller.clientWidth;
          this.querySelector('[data-direction="-1"]').disabled=this.scroller.scrollLeft<2;
          this.querySelector('[data-direction="1"]').disabled=this.scroller.scrollLeft>=max-2;
        };
        this.addEventListener('click',event=>{
          const arrow=event.target.closest('[data-direction]');
          if(arrow){const cell=this.querySelector('.fmc__model');this.scroller.scrollBy({left:cell.getBoundingClientRect().width*Number(arrow.dataset.direction),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}
          const current=event.target.closest('[data-current-link]');
          if(current){
            const target=[...document.querySelectorAll('form[action*="/cart/add"]')].find(form=>!this.contains(form)&&form.getBoundingClientRect().height>0);
            if(target){event.preventDefault();target.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});target.querySelector('button[type="submit"],input,select')?.focus({preventScroll:true});}
          }
        },{signal});
        this.scroller.addEventListener('scroll',update,{passive:true,signal});
        this.observer=new ResizeObserver(update);this.observer.observe(this.scroller);update();
      }
      disconnectedCallback(){this.controller?.abort();this.controller=null;this.observer?.disconnect();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fotric-scenario-finder"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fotric-scenario-finder-v9'))customElements.define('fotric-scenario-finder-v9',class extends HTMLElement{
  connectedCallback(){
    if(this.controller)return;this.controller=new AbortController();
    this.state=this.state||{scene:'',object:'',budget:null,device:'',priority:'everyday',android:false};this.phase=this.phase||'task';
    this.mobile=matchMedia('(max-width:600px)');this.mobile.addEventListener('change',()=>{this.get('tips').open=!this.mobile.matches;this.querySelectorAll('.fsf__alternative').forEach(x=>x.open=!this.mobile.matches);},{signal:this.controller.signal});
    this.addEventListener('click',e=>this.click(e),{signal:this.controller.signal});
    this.addEventListener('change',e=>this.change(e),{signal:this.controller.signal});
    this.addEventListener('submit',e=>this.addToCart(e),{signal:this.controller.signal});
    this.restore();this.get('enhanced').hidden=false;this.render();
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;}
  async addToCart(e){
    const form=e.target.closest('[data-cart-form]');if(!form)return;e.preventDefault();e.stopPropagation();
    if(this.adding||!form.reportValidity())return;this.adding=true;
    const button=form.querySelector('[type=submit]'),notice=this.get('cart-notice');button.disabled=true;button.textContent='Adding…';
    notice.hidden=false;notice.textContent='Adding your camera…';
    const root=window.Shopify?.routes?.root||'/';let added=false;
    try{
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:form.querySelector('[data-variant]').value,quantity:1}],sections:['cart-icon-bubble','cart-drawer'],sections_url:location.pathname})});
      const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||'This item could not be added. Please check the selected package.');added=true;
      notice.replaceChildren();const msg=document.createElement('span');msg.textContent='Added to cart. Keep comparing here, or open your cart when you’re ready.';
      const close=document.createElement('button');close.type='button';close.textContent='Dismiss';close.onclick=()=>notice.hidden=true;notice.append(msg,close);
      const parser=new DOMParser();
      for(const [key,selector] of [['cart-icon-bubble','#cart-icon-bubble'],['cart-drawer','cart-drawer']]){
        if(!data.sections?.[key])continue;const source=parser.parseFromString(data.sections[key],'text/html').querySelector(selector);const target=document.querySelector(selector);
        if(source&&target){target.innerHTML=source.innerHTML;if(key==='cart-drawer')target.classList.remove('is-empty');}
      }
      try{const r=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});if(r.ok){const cart=await r.json();document.querySelectorAll('[data-cart-count],.cart-count-bubble span[aria-hidden=true]').forEach(el=>{el.textContent=cart.item_count;});document.dispatchEvent(new CustomEvent('fotric:cart-updated',{detail:{cart}}));}}catch(error){}
    }catch(error){notice.textContent=added?'Added to cart. Open the cart icon when you’re ready.':(error instanceof TypeError?'We could not confirm the update. Check your cart before trying again.':error.message);}
    finally{this.adding=false;button.textContent='Add to cart';button.disabled=!form.querySelector('[data-variant]').value;}
  }
  get(n){return this.querySelector('[data-'+n+']');}
        get scenes() { return {
  "home": {
    "name": "Home & HVAC",
    "objects": [
      "radiator",
      "floor",
      "window",
      "duct",
      "ac",
      "moisture"
    ]
  },
  "vehicle": {
    "name": "Vehicle Checks",
    "objects": [
      "engine",
      "brakes",
      "vehicle_electrical",
      "cabin"
    ]
  },
  "electrical": {
    "name": "Electrical & Electronics",
    "objects": [
      "panel",
      "connection",
      "pcb"
    ]
  },
  "machinery": {
    "name": "Equipment Maintenance",
    "objects": [
      "motor",
      "pump",
      "bearing",
      "cooling"
    ]
  },
  "outdoor": {
    "name": "Outdoor & Camping",
    "objects": [
      "campsite",
      "garden",
      "campfire",
      "distance"
    ]
  }
}; }
      get examples() { return {
  "radiator": {
    "label": "Radiator cold spots",
    "wide": "Survey the radiator for unheated sections without adjusting focus.",
    "manual": "Adjust focus to inspect a valve or a specific unheated section."
  },
  "floor": {
    "label": "Uneven floor heating",
    "wide": "Survey more floor at once to trace heating patterns and find problem zones.",
    "manual": "Adjust focus on a suspect floor area for a targeted follow-up check."
  },
  "window": {
    "label": "Draughts & heat loss",
    "wide": "Survey a frame and surrounding wall together to prioritise sealing or insulation checks.",
    "manual": "Adjust focus on a suspect frame joint to inspect a possible sealing issue."
  },
  "panel": {
    "label": "Panels & breakers",
    "wide": "Compare several breakers or connections together to spot unusual heating.",
    "manual": "Adjust focus on a suspect breaker or terminal for a targeted check."
  },
  "connection": {
    "label": "Hot connections",
    "wide": "Compare the connection with nearby cables to locate unusual heating.",
    "manual": "Adjust focus on a suspect terminal to help narrow down the problem area."
  },
  "pcb": {
    "label": "Circuit-board faults",
    "close": true
  },
  "motor": {
    "label": "Motors & drives",
    "wide": "Survey motor housings and accessible drive equipment to locate overheating areas for targeted maintenance.",
    "manual": "Adjust focus on a selected motor housing or connection to investigate a local overheating issue."
  },
  "bearing": {
    "label": "Bearings & gearboxes",
    "wide": "Compare accessible bearing or gearbox housings to prioritise maintenance attention.",
    "manual": "Adjust focus on a selected bearing or gearbox area to investigate unusual heating."
  },
  "cooling": {
    "label": "Cooling problems",
    "wide": "Survey equipment for heat build-up and compare conditions after maintenance.",
    "manual": "Adjust focus on a cooling component to investigate a local overheating problem."
  },
  "campsite": {
    "label": "Check a campsite",
    "outdoor": true
  },
  "garden": {
    "label": "Spot nearby animals",
    "outdoor": true
  },
  "distance": {
    "label": "Identify distant animals",
    "support": true
  },
  "duct": {
    "label": "Ducts & airflow",
    "wide": "Survey duct joints and vent surroundings to locate areas worth checking for air or insulation losses.",
    "manual": "Adjust focus on a suspect duct joint or vent area before a targeted airflow check."
  },
  "ac": {
    "label": "Poor AC cooling",
    "wide": "Survey accessible cooling surfaces to decide where poor cooling needs closer investigation.",
    "manual": "Adjust focus on a coil section or pipe connection to investigate an uneven cooling pattern."
  },
  "moisture": {
    "label": "Leaks & damp",
    "wide": "Survey more wall or floor to narrow down the area for moisture checks.",
    "manual": "Adjust focus on a suspect surface patch to guide the next moisture check."
  },
  "engine": {
    "label": "Engine & cooling",
    "wide": "Survey accessible radiator and cooling-system surfaces to locate an area for further checks.",
    "manual": "Adjust focus on a selected hose connection or radiator section to investigate an uneven heat pattern."
  },
  "brakes": {
    "label": "Hot brakes",
    "wide": "View an accessible brake assembly to compare heat patterns on matching sides of the vehicle.",
    "manual": "Adjust focus on an accessible rotor or caliper area to investigate unusual heating."
  },
  "vehicle_electrical": {
    "label": "Vehicle electrics",
    "wide": "Survey accessible fuses, relays and connections to locate an area of unusual heating.",
    "manual": "Adjust focus on a suspect terminal or relay to direct further electrical checks."
  },
  "cabin": {
    "label": "AC & cabin heating",
    "wide": "Compare vent surroundings or a heated seat to locate uneven cooling or heating.",
    "manual": "Adjust focus on a vent surround or heating-element area for a targeted check."
  },
  "pump": {
    "label": "Pumps & circulation",
    "wide": "Survey accessible pump housings and connected pipe surfaces to locate abnormal heat patterns.",
    "manual": "Adjust focus on a selected pump housing or pipe connection to direct a follow-up check."
  },
  "campfire": {
    "label": "Campfire heat",
    "outdoor": true
  }
}; }
      get contextCopy() { return {
  "radiator": {
    "intro": "Find poorly heated radiator sections to target maintenance and restore more even heating, rather than compensating by turning up the thermostat.",
    "record": "Investigate uneven heating and attach room names and repair notes to images for easier before-and-after comparisons.",
    "phone": "Use your Android phone to investigate an unevenly heated radiator and check whether maintenance has improved heat distribution.",
    "phoneCard": "Carry a 40 g attachment for radiator troubleshooting using your Android phone.",
    "wideRole": "Survey uneven heating",
    "manualRole": "Check a problem section",
    "tip": "Investigating an unevenly heated radiator",
    "rows": [
      [
        "Find the problem area",
        "Unheated sections can help direct checks for trapped air, sludge or restricted circulation."
      ],
      [
        "Check the result",
        "Compare images under similar operating conditions before and after bleeding, flushing or other maintenance."
      ],
      [
        "Direct the repair",
        "Check valves and circulation at the identified areas, then compare heating after appropriate bleeding, cleaning or servicing."
      ]
    ]
  },
  "floor": {
    "intro": "Locate underheated floor zones and trace heating routes to focus repairs, helping reduce unnecessary floor opening when investigating a suspected leak.",
    "record": "Investigate an underheated floor zone and label its room and location on the image for repair follow-up.",
    "phone": "Use your Android phone to trace underfloor heating patterns and narrow down a problem zone before further investigation.",
    "phoneCard": "Use a pocket-sized phone attachment to investigate an underheated room or floor zone.",
    "wideRole": "Locate a problem zone",
    "manualRole": "Inspect a suspect area",
    "tip": "Investigating floor heating problems",
    "rows": [
      [
        "Trace the heating pattern",
        "Visible heat traces can help locate heating routes and underheated zones before choosing where to investigate."
      ],
      [
        "Narrow the search",
        "An unusual warm area may help direct a suspected-leak investigation and reduce unnecessary floor opening."
      ],
      [
        "Plan targeted access",
        "Confirm a suspected leak with suitable plumbing checks before opening the floor. Thermal imaging traces surface heat patterns, not a view of hidden pipes."
      ]
    ]
  },
  "window": {
    "intro": "Find signs of draughts and missing insulation so repairs can target heat loss, improving comfort and helping reduce wasted heating or cooling.",
    "record": "Document suspected draughts or heat loss with room and window notes so each repair location is easier to revisit.",
    "phone": "Use your Android phone to investigate draughty windows and doors and identify areas worth sealing or repairing.",
    "phoneCard": "Keep a small camera on hand to investigate draughts and heat loss around the home.",
    "wideRole": "Locate heat-loss areas",
    "manualRole": "Inspect a frame joint",
    "tip": "Finding draughts and heat-loss areas",
    "rows": [
      [
        "Locate areas to check",
        "Patterns around frames and adjacent walls can point to air leakage or insulation weaknesses."
      ],
      [
        "Prioritise repairs",
        "Use the images to select seals or joints for closer inspection and compare the area after repair."
      ],
      [
        "Interpret the pattern",
        "Indoor–outdoor temperature differences help. Reflections, moisture and thermal bridges can produce similar clues; confirm the cause."
      ]
    ]
  },
  "panel": {
    "intro": "Locate unusually hot breakers and terminals to prioritise electrical maintenance, helping reduce the risk of component damage and unplanned interruption.",
    "record": "Record the panel and circuit ID beside an overheating component so the maintenance team can find and recheck it.",
    "phone": "Use your Android phone to locate overheating panel components and identify where electrical checks should begin.",
    "phoneCard": "Carry a compact attachment for scheduled panel checks using your Android phone.",
    "wideRole": "Find suspect components",
    "manualRole": "Check a suspect terminal",
    "tip": "Investigating electrical panel overheating",
    "rows": [
      [
        "Find the suspect component",
        "Unusual heating can flag connections or components affected by resistance or loading problems."
      ],
      [
        "Direct the next check",
        "Record the affected circuit, investigate electrically and re-image after repairs under comparable load."
      ],
      [
        "Confirm and repair safely",
        "Qualified personnel can use electrical tests to confirm the issue and plan corrective work under appropriate safety procedures."
      ]
    ]
  },
  "connection": {
    "intro": "Locate unusually hot cable joints or terminals to help investigate high-resistance connections and prioritise corrective work.",
    "record": "Attach the circuit ID and terminal location to a suspect connection image for repair handover and later reinspection.",
    "phone": "Use your Android phone to locate unusual heating at accessible connections and direct further electrical checks.",
    "phoneCard": "Check accessible connections with a compact attachment, subject to target size and viewing distance.",
    "wideRole": "Locate a suspect joint",
    "manualRole": "Inspect the connection",
    "tip": "Investigating a hot electrical connection",
    "rows": [
      [
        "Find the suspect joint",
        "Loose or deteriorated connections can generate heat from increased resistance. Compare similar connections under comparable load."
      ],
      [
        "Plan the follow-up",
        "Use the location to direct electrical checks and assess the result after corrective work."
      ],
      [
        "Check access and image size",
        "Qualified personnel must follow electrical safety procedures. Small or reflective targets need care; confirm target size and viewing distance."
      ]
    ]
  },
  "pcb": {
    "intro": "Locate abnormal component heating to narrow down circuit-board troubleshooting and reduce time spent checking unaffected areas.",
    "record": "Locate abnormal component heating on a circuit board to narrow down fault-finding and investigate heat build-up during testing.",
    "phone": "Locate abnormal component heating on a circuit board to narrow down fault-finding and investigate heat build-up during testing.",
    "tip": "Choosing a camera for circuit-board work",
    "rows": [
      [
        "Narrow down fault-finding",
        "A local hotspot can direct attention to a component or board area for electrical testing."
      ],
      [
        "Review heat build-up",
        "Comparing operating states or a known-good board can help investigate an overheating issue."
      ],
      [
        "Match close-up performance",
        "TK6 offers manual focus and imaging from 0.15 m. Share the component size and working distance to confirm suitability for tiny-target measurement."
      ]
    ]
  },
  "motor": {
    "intro": "Locate abnormal heat on motors and accessible drive equipment to prioritise maintenance, helping reduce the risk of damage and unplanned downtime.",
    "record": "Label motor and drive IDs with operating notes so maintenance teams can track changes and revisit affected equipment.",
    "phone": "Use your Android phone to locate an overheating motor or drive area and focus maintenance checks before the problem escalates.",
    "phoneCard": "Carry a compact Android attachment for routine motor and drive checks.",
    "wideRole": "Locate equipment overheating",
    "manualRole": "Investigate a hot area",
    "tip": "Planning motor and drive maintenance",
    "rows": [
      [
        "Locate the concern",
        "Survey accessible housings and connections for unusual heating under comparable operating conditions."
      ],
      [
        "Plan maintenance",
        "Use the location and operating context to direct cooling, lubrication, loading or connection checks."
      ],
      [
        "Verify the improvement",
        "Use appropriate mechanical and electrical tests to confirm the cause, then re-image after corrective work."
      ]
    ]
  },
  "bearing": {
    "intro": "Find unusually hot bearing or gearbox areas to direct lubrication and wear checks, helping schedule maintenance before a costly stoppage.",
    "record": "Label bearing and gearbox locations on images to track recurring heating and share maintenance priorities.",
    "phone": "Use your Android phone to locate unusual heat around bearings or gearboxes and direct follow-up maintenance checks.",
    "phoneCard": "Use your phone to survey accessible bearing and gearbox housings during maintenance rounds.",
    "wideRole": "Prioritise maintenance checks",
    "manualRole": "Inspect a selected housing",
    "tip": "Planning bearing and gearbox checks",
    "rows": [
      [
        "Find an abnormal trend",
        "A housing that runs unusually hot may warrant lubrication, loading or wear checks."
      ],
      [
        "Schedule follow-up",
        "Compare like-for-like operating conditions and record the location for maintenance and reinspection."
      ],
      [
        "Confirm and follow up",
        "Combine thermal findings with lubrication, vibration or other mechanical checks. Recheck after service under comparable conditions."
      ]
    ]
  },
  "cooling": {
    "intro": "Find equipment heat build-up to target cooling maintenance, helping avoid heat-related damage and assess whether servicing has improved performance.",
    "record": "Label equipment and cooling repairs on thermal images to compare heat build-up before and after maintenance.",
    "phone": "Use your Android phone to investigate equipment heat build-up and compare the result after cooling maintenance.",
    "phoneCard": "Use your phone to document overheating areas during routine cooling checks.",
    "wideRole": "Survey heat build-up",
    "manualRole": "Check a cooling component",
    "tip": "Investigating equipment cooling problems",
    "rows": [
      [
        "Locate the affected area",
        "Surface heat patterns can direct checks towards ventilation, fans or heat-dissipation components."
      ],
      [
        "Check the improvement",
        "Repeat the inspection after cleaning or repairs with comparable load and ambient conditions."
      ],
      [
        "Verify cooling performance",
        "Confirm airflow, fan operation or coolant flow separately. The thermal image does not measure these directly."
      ]
    ]
  },
  "campsite": {
    "intro": "Look for people or nearby animal activity around your tent after dark, helping you decide where to look more closely.",
    "record": "",
    "phone": "Use your Android phone to spot nearby activity around your tent after dark and locate areas to check more closely.",
    "phoneCard": "Bring thermal viewing to campsite surroundings with a 40 g camera connected to your Android phone.",
    "tip": "Using thermal imaging around camp",
    "rows": [
      [
        "Look around camp",
        "Thermal contrast can help reveal people or animals that are difficult to notice in darkness."
      ],
      [
        "Direct your attention",
        "Use a visible heat shape to decide where to look more closely. Target size, distance and surroundings affect the detail available."
      ],
      [
        "Choose the right setup",
        "Confirm Android compatibility and included accessories. Distance, obstructions and conditions affect visibility; this guide does not establish unattended protection."
      ]
    ]
  },
  "garden": {
    "intro": "Find nearby animal activity after dark and narrow down where to look when searching for a pet in a garden or campsite.",
    "record": "",
    "phone": "Use your Android phone to spot nearby animal activity at night or narrow down a pet search around your garden.",
    "phoneCard": "Use the phone screen to locate nearby animal heat when darkness makes visual searching difficult.",
    "tip": "Looking for animals after dark",
    "rows": [
      [
        "Direct your search",
        "Heat contrast can help draw attention to a nearby animal so you know where to look more closely."
      ],
      [
        "Understand the limits",
        "Walls and dense vegetation can hide the target. Finding a heat shape does not establish the animal species or guarantee finding a pet."
      ],
      [
        "Check your distance",
        "Tell us the animal size and viewing distance if you need identification rather than simply locating activity."
      ]
    ]
  },
  "distance": {
    "intro": "If your task is to recognise an animal at a distance, match the camera to the animal size and viewing range before buying.",
    "record": "",
    "phone": "",
    "tip": "Matching a camera to distant animal observation",
    "rows": [
      [
        "Define the job",
        "Do you need to find an animal, distinguish it from a person, or recognise its species? These require different levels of detail."
      ],
      [
        "Describe the target",
        "Provide the approximate animal size, viewing distance and typical surroundings."
      ],
      [
        "Get a suitability check",
        "Use the contact link to discuss the task. A nearby campsite use case does not establish long-range identification performance."
      ]
    ]
  },
  "duct": {
    "intro": "Locate signs of duct leakage, insulation loss or uneven air delivery so sealing and servicing can target the areas wasting heating or cooling.",
    "record": "Label duct joints and vents needing attention so repair teams can revisit each location and compare conditions after sealing or servicing.",
    "phone": "Use your Android phone to survey accessible ducts and vents, helping target checks for air losses and uneven heating or cooling.",
    "phoneCard": "Carry a compact phone attachment to find where duct sealing or airflow checks should begin.",
    "wideRole": "Survey potential air losses",
    "manualRole": "Check a duct joint",
    "tip": "Targeting duct and ventilation repairs",
    "rows": [
      [
        "Locate the area",
        "Thermal patterns around accessible duct joints and vents help identify locations for sealing, insulation or air-delivery checks."
      ],
      [
        "Reduce wasted work",
        "Survey several locations before choosing where to investigate, then compare the affected area after maintenance."
      ],
      [
        "Complete the check",
        "Measure airflow or inspect the duct to confirm a restriction. The camera observes surfaces rather than air moving inside the duct."
      ]
    ]
  },
  "ac": {
    "intro": "Investigate weak or uneven cooling by comparing coil and pipe surface patterns, helping focus servicing and avoid replacing parts without supporting checks.",
    "record": "Record unit IDs and affected cooling areas so technicians can compare service findings and revisit the same locations after repairs.",
    "phone": "Use your Android phone to investigate weak cooling and locate accessible coil or pipe areas for targeted service checks.",
    "phoneCard": "Add a compact thermal view to your Android phone for investigating poor air-conditioning performance.",
    "wideRole": "Survey uneven cooling",
    "manualRole": "Inspect a cooling section",
    "tip": "Directing air-conditioning service checks",
    "rows": [
      [
        "Find where to investigate",
        "Uneven patterns across accessible coils and pipes can help direct checks of airflow, heat exchange and system operation."
      ],
      [
        "Assess the service result",
        "Compare the same areas after cleaning or repair under similar operating conditions to assess improvement."
      ],
      [
        "Use the right test",
        "Use appropriate HVAC measurements to confirm the cause. Refrigerant leakage requires a refrigerant-compatible detector; these cameras do not directly image the gas."
      ]
    ]
  },
  "moisture": {
    "intro": "Narrow down suspected leaks or damp areas before opening walls or floors, helping reduce unnecessary demolition and focus repair work.",
    "record": "Add room names and damp-area locations to images so investigation and repair teams can return to the same places.",
    "phone": "Use your Android phone to survey suspected damp areas and choose where to confirm moisture before opening a larger surface.",
    "phoneCard": "Survey walls and floors with your phone to target follow-up moisture checks.",
    "wideRole": "Narrow the search area",
    "manualRole": "Check a suspect patch",
    "tip": "Reducing unnecessary opening during leak checks",
    "rows": [
      [
        "Survey the surface",
        "Moisture or a warm leaking pipe can create a surface pattern that helps narrow the search area."
      ],
      [
        "Confirm before opening",
        "Use a moisture meter and suitable plumbing checks at the identified areas to guide targeted access and repairs."
      ],
      [
        "What the image represents",
        "This is surface-based investigation, not a view through the wall. Materials and temperature contrast affect how visible the pattern is."
      ]
    ]
  },
  "engine": {
    "intro": "Investigate engine overheating by surveying accessible cooling-system surfaces, helping focus checks on the radiator, hoses or circulation before choosing a repair.",
    "record": "Add vehicle and inspection notes to cooling-system images so technicians can revisit the same areas and compare findings after repairs.",
    "phone": "Use your Android phone to locate unusual heat patterns around accessible cooling-system parts and narrow down an engine-overheating investigation.",
    "phoneCard": "Carry a compact attachment for checking cooling-system heat patterns with your Android phone.",
    "wideRole": "Survey the cooling system",
    "manualRole": "Inspect a selected area",
    "tip": "Investigating engine and cooling problems",
    "rows": [
      [
        "Focus the investigation",
        "Compare accessible radiator, hose and housing surfaces as the system warms up to choose where circulation or cooling checks should begin."
      ],
      [
        "Support targeted repairs",
        "Record the affected area and repeat the inspection after service under comparable operating conditions."
      ],
      [
        "Choose a suitable setup",
        "Match the target temperature to the camera range and use a safe viewing position. Cooling-system service checks confirm the cause."
      ]
    ]
  },
  "brakes": {
    "intro": "Compare matching brake assemblies for unusual heating to help investigate brake drag and direct servicing before uneven wear becomes a bigger repair.",
    "record": "Label the wheel position and inspection conditions on brake images so a technician can follow up on the correct assembly.",
    "phone": "Use your Android phone to compare accessible brake surfaces and find which wheel needs closer attention for unusual heating.",
    "phoneCard": "Use your phone to document heat differences between matching brake assemblies for follow-up inspection.",
    "wideRole": "Compare brake assemblies",
    "manualRole": "Inspect a suspect area",
    "tip": "Investigating abnormal brake heating",
    "rows": [
      [
        "Locate the concern",
        "Compare matching sides under similar conditions; a brake that remains unusually hot can warrant a drag or caliper check."
      ],
      [
        "Direct servicing",
        "Record the wheel position and have the affected assembly inspected, then compare again after repair."
      ],
      [
        "Inspect safely",
        "Inspect only with the vehicle secured and avoid contact with hot parts. Match target temperature to the camera range; heat patterns support a brake inspection."
      ]
    ]
  },
  "vehicle_electrical": {
    "intro": "Locate unusually hot fuses, relays and cable connections to narrow down vehicle electrical troubleshooting and focus testing on the affected area.",
    "record": "Add vehicle and circuit notes to images so overheating connections are easier to find again during repair and reinspection.",
    "phone": "Use your Android phone to locate unusual heating in accessible vehicle wiring and components before targeted electrical testing.",
    "phoneCard": "Add a compact thermal view to your phone for checking accessible vehicle electrical components.",
    "wideRole": "Locate suspect components",
    "manualRole": "Inspect a connection",
    "tip": "Investigating vehicle electrical heating",
    "rows": [
      [
        "Find where to test",
        "Unusual heating at accessible terminals, fuses or relays can help focus checks for high resistance or component problems."
      ],
      [
        "Make follow-up easier",
        "Record the circuit location and operating state, then compare images after corrective work."
      ],
      [
        "Match the inspection",
        "Use the appropriate electrical tests and service procedures. Small targets require suitable focus and working distance; high-voltage systems require qualified personnel."
      ]
    ]
  },
  "cabin": {
    "intro": "Locate uneven cabin cooling or heating and underperforming heated-seat areas, helping direct comfort-system checks and assess the effect of repairs.",
    "record": "Label vent positions or heated-seat areas on images so technicians can compare cabin comfort problems before and after service.",
    "phone": "Use your Android phone to compare vent surroundings and heated-seat surfaces when investigating poor cabin cooling or heating.",
    "phoneCard": "Use your phone to inspect uneven cabin heating or cooling without carrying a separate display.",
    "wideRole": "Compare cabin surfaces",
    "manualRole": "Inspect a local area",
    "tip": "Checking cabin heating and cooling",
    "rows": [
      [
        "Locate uneven performance",
        "Compare corresponding vent surroundings or heated-seat surfaces during operation to locate areas needing attention."
      ],
      [
        "Check the repair result",
        "Repeat images with similar HVAC settings and conditions after service to assess changes in surface heat distribution."
      ],
      [
        "Complete the diagnosis",
        "Measure air temperature and airflow as needed. Use a refrigerant-compatible detector for suspected refrigerant leakage; these cameras image surface heat."
      ]
    ]
  },
  "pump": {
    "intro": "Locate abnormal heat around pumps and connected pipework to direct circulation and maintenance checks, helping reduce unfocused troubleshooting and disruption.",
    "record": "Add pump IDs and pipe locations to images so maintenance teams can revisit the same points and compare conditions after servicing.",
    "phone": "Use your Android phone to survey accessible pump and pipe surfaces and locate where circulation checks should begin.",
    "phoneCard": "Carry a compact Android attachment for thermal checks around pumps and pipework.",
    "wideRole": "Survey the pump area",
    "manualRole": "Inspect a selected point",
    "tip": "Planning pump and circulation checks",
    "rows": [
      [
        "Locate a concern",
        "Compare pump housings and connected pipe surfaces under comparable operation to identify unusual heating or an unexpected temperature pattern."
      ],
      [
        "Direct maintenance",
        "Use the location to focus checks on circulation, cooling or mechanical condition, and document the result after service."
      ],
      [
        "Complete the check",
        "Confirm flow, pressure and equipment condition with appropriate measurements. Keep a safe viewing position around moving and hot equipment."
      ]
    ]
  },
  "campfire": {
    "intro": "Locate remaining hot areas around a campfire to focus cooling and follow-up checks before leaving your campsite.",
    "record": "",
    "phone": "Use your Android phone to locate remaining campfire heat and direct further cooling during your final campsite checks.",
    "phoneCard": "Carry a 40 g thermal attachment to check where campfire heat remains on your phone screen.",
    "tip": "Checking residual campfire heat",
    "rows": [
      [
        "Locate remaining heat",
        "Survey visible ground and fire-pit surfaces for hot areas that need further cooling."
      ],
      [
        "Recheck the area",
        "Use repeat views to direct attention as cooling progresses, keeping the camera and phone safely away from heat."
      ],
      [
        "Complete extinguishing checks",
        "Follow local fire guidance and confirm extinguishment through the required physical checks. A thermal view alone cannot certify that a fire is out."
      ]
    ]
  }
}; }

  get models(){return {
    therm5:{focus:'wide',label:'FOCUS-FREE EVERYDAY SCAN',facts:['50° × 38° view','Focus-free','320 × 240'],benefit:'Focus-free scanning with a 3.2-inch screen.'},
    tk5:{focus:'wide',label:'WIDE VIEW · 3.5-INCH SCREEN',facts:['49° × 37° view','Focus-free','3.5-inch screen'],benefit:'A 3.5-inch screen for focus-free checks.'},
    tk6:{focus:'detail',label:'MANUAL FOCUS · TARGETED CHECKS',facts:['25° × 19° view','Manual focus','384 × 288'],benefit:'Adjust focus on a specific component.'},
    tk7:{focus:'wide',label:'WIDE VIEW · NOTES & WI-FI',facts:['49° × 37° view','Focus-free','Notes + Wi-Fi'],benefit:'Add notes and transfer files over Wi-Fi.'},
    tk8:{focus:'detail',label:'MANUAL FOCUS · NOTES & WI-FI',facts:['25° × 19° view','Manual focus','Notes + Wi-Fi'],benefit:'Manual focus with notes and Wi-Fi transfer.'},
    ti3:{focus:'auto',label:'TURBOFOCUS · NARROWER VIEW',facts:['25° × 19° view','TurboFocus','160 × 120'],benefit:'TurboFocus and a 5-inch screen with a narrower view.'},
    ti4:{focus:'auto',label:'TURBOFOCUS · WIDER VIEW',facts:['44° × 33° view','TurboFocus','320 × 240'],benefit:'TurboFocus and a 5-inch screen with a wider view.'},
    tp320a:{focus:'phone',label:'ANDROID · POCKET-SIZE',facts:['60° × 45° view','Focus-free','Android 12+'],benefit:'View thermal patterns on your compatible Android phone.'},
    camping:{focus:'phone',label:'ANDROID · OUTDOOR HEAT VIEW',facts:['60° × 45° view','Focus-free','Android 12+'],benefit:'View nearby heat patterns on your compatible Android phone.'}
  };}
  catalog(){return [...this.querySelectorAll('template[data-model]')].map(t=>{
    const variants=[...t.content.querySelectorAll('option[data-price]')].map(o=>({id:o.value,price:Number(o.dataset.price),formatted:o.dataset.formatted,title:o.textContent})).filter(v=>Number.isFinite(v.price));
    return {key:t.dataset.model,id:t.dataset.productId,t,variants,price:Math.min(...variants.map(v=>v.price)),...this.models[t.dataset.model]};
  }).filter(p=>p.variants.length&&p.focus);}
  taskKeys(scene){return this.scenes[scene].objects.filter(k=>k!=='distance'&&this.pool(k,scene).length);}
  pool(object=this.state.object,scene=this.state.scene){
    return this.catalog().filter(p=>scene==='outdoor'?p.key==='camping'||(p.key==='tp320a'&&!this.catalog().some(x=>x.key==='camping')):object==='pcb'?p.key==='tk6':p.key!=='camping');
  }
  devices(){const pool=this.pool(),out=[];if(pool.some(p=>p.focus!=='phone'))out.push(['handheld','Standalone camera']);if(pool.some(p=>p.focus==='phone'))out.push(['phone','My Android phone']);if(out.length===2)out.push(['either','Either format']);return out;}
  priorities(){const p=this.pool();const list=[['everyday','Everyday checks']];if(this.state.device!=='phone'&&p.some(x=>['tk7','tk8'].includes(x.key)))list.push(['notes','Notes & Wi-Fi']);if(this.state.device!=='phone'&&p.some(x=>x.focus==='auto'))list.push(['auto','Autofocus & 5-inch screen']);return list;}
  normalize(){
    if(!this.devices().some(([k])=>k===this.state.device))this.state.device='';
    if(!this.priorities().some(([k])=>k===this.state.priority))this.state.priority='everyday';
  }
  filtered(){const {device,priority,budget,android}=this.state;
    return this.pool().filter(p=>device==='handheld'?p.focus!=='phone':device==='phone'?p.focus==='phone':device==='either').filter(p=>p.focus!=='phone'||android).filter(p=>priority==='notes'?['tk7','tk8'].includes(p.key):priority==='auto'?p.focus==='auto':true).filter(p=>budget===0||p.price<=budget);
  }
  profile(){return ['pcb','connection','vehicle_electrical','bearing','brakes','ac'].includes(this.state.object)?'detail':'wide';}
  ranked(){const focus=this.profile(),seen=new Set();return this.filtered().sort((a,b)=>{
    const rank=p=>this.state.priority==='everyday'?(p.focus===focus?0:p.focus==='phone'?1:p.focus==='auto'?2:3):0;
    return rank(a)-rank(b)||a.price-b.price;
  }).filter(p=>{if(seen.has(p.id))return false;seen.add(p.id);return true;});}
  recommendations(){const all=this.ranked();if(all.length<2)return all;const first=all[0];
    const alternative=all.slice(1).find(p=>p.focus!==first.focus)||all.slice(1).find(p=>['tk7','tk8'].includes(p.key)!==['tk7','tk8'].includes(first.key))||all[1];
    return [first,alternative];}
  storageKey(){return 'fotric-selector-v8:'+location.pathname+':'+this.id;}
  save(){try{const saved={state:this.state,phase:this.phase,currency:this.dataset.currency};sessionStorage.setItem(this.storageKey(),JSON.stringify(saved));const url=new URL(location.href);if(url.searchParams.has('camera_selection')){url.searchParams.set('camera_selection',JSON.stringify({...saved,state:{...this.state,android:false}}));history.replaceState(null,'',url.href);}}catch(e){}}
  restore(){try{const encoded=new URL(location.href).searchParams.get('camera_selection');const saved=encoded?JSON.parse(encoded):JSON.parse(sessionStorage.getItem(this.storageKey())||'null');if(!saved)return;
    const x=saved.state;if(!x||!this.scenes[x.scene]||!this.taskKeys(x.scene).includes(x.object))return;
    this.state={scene:x.scene,object:x.object,budget:saved.currency===this.dataset.currency&&Number.isFinite(x.budget)&&x.budget>=0&&x.budget<=100000000?x.budget:null,device:['handheld','phone','either'].includes(x.device)?x.device:'',priority:['everyday','notes','auto'].includes(x.priority)?x.priority:'everyday',android:encoded?false:x.android===true};
    this.normalize();this.phase=saved.phase==='results'&&this.ready()?'results':'preferences';
  }catch(e){}}
  money(cents){return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency||'EUR',maximumFractionDigits:cents%100?2:0}).format(cents/100);}
  button(label,key,value,selected=false){const b=document.createElement('button');b.type='button';b.dataset[key]=value;b.textContent=label;b.setAttribute('aria-pressed',String(selected));return b;}
  choices(el,items,key,value){el.replaceChildren(...items.map(([v,label])=>this.button(label,key,v,String(value)===String(v))));}
  scrollToTarget(el,force=false){if(!el)return;let offset=16;document.querySelectorAll('sticky-header,.shopify-section-header,header,.fotric-anchor-nav').forEach(h=>{const r=h.getBoundingClientRect();if(['sticky','fixed'].includes(getComputedStyle(h).position)&&r.top<=offset&&r.bottom>0&&r.height<250)offset=Math.max(offset,r.bottom+16);});const r=el.getBoundingClientRect();if(force||r.top<offset||r.top>innerHeight-80)window.scrollTo({top:Math.max(0,scrollY+r.top-offset),behavior:'auto'});el.focus?.({preventScroll:true});}
  click(e){const b=e.target.closest('button,a[data-browse]');if(!b||!this.contains(b)||b.type==='submit')return;
    if(b.matches('[data-browse]')){const u=new URL(b.href,location.href),g=document.querySelector('#product-grid')||document.querySelector('[id^="ProductGridContainer"]');if(g&&u.origin===location.origin&&u.pathname===location.pathname&&!u.search){e.preventDefault();g.tabIndex=-1;this.scrollToTarget(g,true);}return;}
    const x=b.dataset;
    if(x.scene){this.state.scene=x.scene;this.state.object='';this.phase='task';}
    else if(x.task){this.state.object=x.task;this.normalize();this.phase='preferences';}
    else if(x.budget!==undefined)this.state.budget=Number(x.budget);
    else if(x.device){this.state.device=x.device;this.normalize();}
    else if(x.priority)this.state.priority=x.priority;
    else if(x.step){if(x.step==='preferences'&&!this.state.object)return;this.phase=x.step;}
    else if(x.action==='share'){const url=new URL(location.href);url.searchParams.set('camera_selection',JSON.stringify({state:{...this.state,android:false},phase:'results',currency:this.dataset.currency}));navigator.clipboard?.writeText(url.href).then(()=>this.get('share-status').textContent='Selection link copied.').catch(()=>this.get('share-status').textContent='Copy this link: '+url.href);return;}
    else if(x.action==='results'){if(!this.ready())return;this.phase='results';}
    else if(x.action==='reset'){this.state={scene:'',object:'',budget:null,device:'',priority:'everyday',android:false};this.phase='task';const url=new URL(location.href);url.searchParams.delete('camera_selection');history.replaceState(null,'',url.href);}
    else return;
    this.render();if(x.task||x.step||x.action)this.scrollToTarget(this.phase==='results'?this.get('result-title'):this.phase==='preferences'?this.get('preferences-title'):this.get('task-title'));
  }
  change(e){if(e.target.matches('[data-custom-budget]')){const v=Number(e.target.value);if(!Number.isFinite(v)||v<=0||v>1000000){e.target.setCustomValidity('Enter a maximum budget greater than zero.');e.target.reportValidity();return;}e.target.setCustomValidity('');this.state.budget=Math.round(v*100);this.render();}if(e.target.matches('[data-android]')){this.state.android=e.target.checked;this.render();}if(e.target.matches('[data-variant]'))this.syncPrice(e.target.closest('[data-card]'));}
  ready(){return this.state.budget!==null&&Boolean(this.state.device)&&(!(this.state.device==='phone')||this.state.android);}
  syncPrice(card){const select=card.querySelector('[data-variant]'),selected=select.selectedOptions[0],priced=[...select.options].filter(x=>x.dataset.price&&!x.disabled),min=priced.reduce((a,b)=>Number(a.dataset.price)<Number(b.dataset.price)?a:b,priced[0]);
    card.querySelector('[data-price]').textContent=selected?.dataset.formatted||((priced.length>1?'From ':'')+(min?.dataset.formatted||''));
    card.querySelector('[data-budget-status]').textContent=this.state.budget===0?'No budget limit selected':selected?.dataset.price?'Within your '+this.money(this.state.budget)+' budget':'Packages within your '+this.money(this.state.budget)+' budget';
    card.querySelector('[type=submit]').disabled=!select.value;
  }
  card(p,index){const card=p.t.content.firstElementChild.cloneNode(true);card.querySelector('[data-role]').textContent=p.label;card.prepend(card.querySelector('[data-role]'));
    const context=this.contextCopy[this.state.object],ex=this.examples[this.state.object];
    const reason=this.state.object==='pcb'?'Manually focus on a suspect board area to investigate component heating.':p.focus==='phone'?context.phoneCard:p.focus==='detail'?ex.manual:p.focus==='auto'?'Inspect '+ex.label.toLowerCase()+' with TurboFocus and a 5-inch screen.':ex.wide;
    card.querySelector('[data-reason]').textContent=reason||p.benefit;
    const why=document.createElement('p');why.className='fsf__why';why.textContent='Why this option: '+p.benefit+' '+(p.focus==='detail'?'Choose it for a selected component; manual focusing takes an extra adjustment.':p.focus==='wide'?'Choose it for an area overview without adjusting focus.':p.focus==='auto'?'Choose it when automatic focusing and a larger display matter to your workflow.':'Choose it if carrying a separate handheld camera is less convenient.');card.querySelector('.fsf__product-copy').append(why);
    card.querySelector('[data-facts]').replaceChildren(...p.facts.map(v=>{const li=document.createElement('li');li.textContent=v;return li;}));
    const select=card.querySelector('[data-variant]');[...select.options].forEach(o=>{if(o.dataset.price&&this.state.budget!==0&&Number(o.dataset.price)>this.state.budget)o.remove();});
    if(p.variants.length===1){select.value=String(p.variants[0].id);select.closest('label').hidden=true;}else{select.value='';}
    this.syncPrice(card);return card;
  }
  render(){const s=this.state;this.save();this.dataset.phase=this.phase;
    this.querySelectorAll('[data-step]').forEach(b=>{b.disabled=b.dataset.step==='preferences'&&!s.object;b.setAttribute('aria-current',b.dataset.step===(this.phase==='task'?'task':'preferences')?'step':'false');});
    this.querySelectorAll('[data-scene]').forEach(b=>{b.hidden=!this.taskKeys(b.dataset.scene).length;b.setAttribute('aria-pressed',String(b.dataset.scene===s.scene));});
    this.get('task-panel').hidden=this.phase!=='task';this.get('preferences').hidden=this.phase!=='preferences';this.get('results').hidden=this.phase!=='results';
    this.get('task-title').hidden=!s.scene;
    this.choices(this.get('tasks'),s.scene?this.taskKeys(s.scene).map(k=>[k,this.examples[k].label]):[],'task',s.object);
    const summary=this.get('summary');summary.hidden=!s.object||this.phase==='task';summary.replaceChildren();
    if(s.object){const t=document.createElement('span');t.textContent=this.scenes[s.scene].name+' · '+this.examples[s.object].label;summary.append(t,this.button('Edit task','step','task'));if(this.phase==='results')summary.append(this.button('Edit budget & setup','step','preferences'));}
    if(this.phase==='task'){this.get('status').textContent='Step 1: choose your inspection task.';return;}
    const caps=[...new Set(['budgetOne','budgetTwo','budgetThree','budgetFour'].map((k,i)=>Number(this.dataset[k]||[600,1000,2500,3500][i])*100).filter(n=>n>0))].sort((a,b)=>a-b);
    this.get('custom-budget').value=s.budget>0?s.budget/100:'';
    this.get('currency').textContent='('+ (this.dataset.currency||'EUR')+')';
    this.choices(this.get('budgets'),[...caps.map(n=>[n,'Up to '+this.money(n)]),[0,'No limit']],'budget',s.budget);
    this.choices(this.get('devices'),this.devices(),'device',s.device);
    this.get('compat').hidden=!['phone','either'].includes(s.device);this.get('android').checked=s.android;
    this.choices(this.get('priorities'),this.priorities(),'priority',s.priority);this.get('optional').hidden=this.priorities().length<2;
    this.get('preference-note').textContent=s.device==='either'&&!s.android?'Phone attachments are included only when you confirm Android compatibility.':s.device==='phone'&&!s.android?'Confirm your phone compatibility to include this camera.':'';
    this.querySelector('[data-action=results]').disabled=!this.ready();
    if(this.phase!=='results'){this.get('status').textContent='Step 2: choose a budget and camera setup.';return;}
    const picks=this.recommendations();const others=this.ranked().filter(p=>!picks.some(x=>x.id===p.id));this.get('more').hidden=!others.length;this.get('more').open=false;this.get('more-products').replaceChildren(...others.map((p,i)=>this.card(p,i+2)));this.querySelector('[data-action=share]').hidden=!picks.length;this.get('products').replaceChildren();
    picks.forEach((p,i)=>{const card=this.card(p,i);if(!i){this.get('products').append(card);return;}const alt=document.createElement('details'),sum=document.createElement('summary');alt.className='fsf__alternative';alt.open=!this.mobile.matches;sum.textContent='Compare: '+p.benefit;alt.append(sum,card);this.get('products').append(alt);});
    this.get('result-title').textContent=picks.length?'Your camera options':'No matching camera within these choices';
    this.get('explanation').textContent=picks.length?'Compare an area overview with a targeted check where available. All shown options meet your device choice and '+(s.budget===0?'selected preferences.':this.money(s.budget)+' maximum budget.'):'Try a higher budget or change your device or feature preference. Your budget has not been increased automatically.';
    const notes={pcb:'Share your component size and working distance—we can help check the right setup for small-component measurements.',moisture:'Use heat patterns to narrow down the area, then confirm moisture with a moisture meter.',duct:'Locate uneven surface temperatures, then check airflow with the appropriate instrument.',ac:'Compare surface temperatures to guide follow-up cooling-system checks; thermal imaging does not show refrigerant gas.',campfire:'Use the thermal view to locate remaining heat, then complete physical extinguishing checks.'};
    let note=notes[s.object]||'';if(picks.some(p=>p.focus==='phone'))note+=' Requires Android 12+ with USB-C OTG; not compatible with iPhone.';
    this.get('note').textContent=note;this.get('note').hidden=!note||!picks.length;
    this.get('tips').hidden=!picks.length;this.get('tips').open=!this.mobile.matches;
    const rows=s.object==='radiator'?[['Find where heating is uneven','See which radiator sections stay cooler, so you can focus checks on the affected area.'],['Narrow down the next check','Use the location of cooler patches to guide checks for trapped air or restricted circulation; the image alone does not identify the cause.'],['See whether maintenance helped','Compare before-and-after images at similar heating settings to see whether warmth is distributed more evenly.']]:this.contextCopy[s.object].rows;
    this.get('guidance').replaceChildren(...rows.map(([a,b])=>{const x=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=a;dd.textContent=b;x.append(dt,dd);return x;}));
    this.get('status').textContent=picks.length+' camera options meet your choices.';
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fotric-trust-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fotric-service-ticker')) {
    customElements.define('fotric-service-ticker', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const on = (el, name, fn, options = {}) => el.addEventListener(name, fn, { ...options, signal: this.abort.signal });
        this.view = this.querySelector('.fservice__viewport');
        this.track = this.querySelector('.fservice__track');
        this.group = this.querySelector('.fservice__group');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.pauses = new Set();
        this.visible = true;
        this.x = 0;
        this.last = 0;
        this.rebuild = () => {
          this.track.querySelectorAll('[data-copy]').forEach(el => el.remove());
          this.enabled = this.dataset.auto === 'true' && !this.motion.matches && this.group.children.length > 1;
          if (this.enabled) {
            const copies = Math.ceil(this.view.clientWidth / Math.max(1, this.group.getBoundingClientRect().width));
            for (let i = 0; i < copies; i++) {
            const copy = this.group.cloneNode(true);
            copy.dataset.copy = 'true';
            copy.setAttribute('aria-hidden', 'true');
            copy.querySelectorAll('*').forEach(el => {
              el.removeAttribute('id');
              el.removeAttribute('data-shopify-editor-block');
              if (el.matches('a,button,[tabindex]')) el.setAttribute('tabindex', '-1');
            });
            this.track.append(copy);
            }
          }
          this.period = this.group.getBoundingClientRect().width;
          this.x = 0;
          this.view.scrollLeft = 0;
        };
        on(this, 'mouseenter', () => this.pauses.add('hover'));
        on(this, 'mouseleave', () => this.pauses.delete('hover'));
        on(this.view, 'focusin', () => this.pauses.add('focus'));
        on(this.view, 'focusout', e => { if (!this.view.contains(e.relatedTarget)) this.pauses.delete('focus'); });
        const rest = () => {
          this.pauses.add('touch');
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.pauses.delete('touch'), 2000);
        };
        on(this.view, 'pointerdown', () => { clearTimeout(this.timer); this.pauses.add('touch'); });
        on(window, 'pointerup', () => { if (this.pauses.has('touch')) rest(); });
        on(window, 'pointercancel', () => { if (this.pauses.has('touch')) rest(); });
        on(this.view, 'wheel', rest, { passive: true });
        on(this.view, 'scroll', () => { if (this.pauses.size) this.x = this.view.scrollLeft; }, { passive: true });

        on(this, 'shopify:block:select', e => {
          this.pauses.add('editor');
          const item = e.target.closest('.fservice__item');
          if (item) this.view.scrollLeft += item.getBoundingClientRect().left - this.view.getBoundingClientRect().left - 22;
        });
        on(this, 'shopify:block:deselect', () => this.pauses.delete('editor'));
        on(this.motion, 'change', this.rebuild);
        this.resize = new ResizeObserver(this.rebuild);
        this.resize.observe(this.view);
        this.resize.observe(this.group);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
        this.observer.observe(this);
        this.rebuild();
        const tick = time => {
          const dt = this.last ? Math.min(time - this.last, 50) : 0;
          this.last = time;
          if (this.enabled && this.period > 0 && !this.pauses.size && this.visible && !document.hidden) {
            this.x = (this.x + dt * Number(this.dataset.speed || 22) / 1000) % this.period;
            this.view.scrollLeft = this.x;
          }
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        this.resize?.disconnect();
        this.observer?.disconnect();
        this.abort?.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fotric-video-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fotric-video-hub')) {
    const metadataRequests = new Map();
    const fetchMetadata = videoId => {
      if (metadataRequests.has(videoId)) return metadataRequests.get(videoId);
      const abort = new AbortController();
      const timer = setTimeout(() => abort.abort(), 8000);
      const url = 'https://www.youtube.com/oembed?url=' + encodeURIComponent('https://www.youtube.com/watch?v=' + videoId) + '&format=json';
      const request = fetch(url, { signal: abort.signal, credentials: 'omit' })
        .then(response => { if (!response.ok) throw new Error('Metadata unavailable'); return response.json(); })
        .then(data => ({ title: typeof data.title === 'string' ? data.title.trim() : '', creator: typeof data.author_name === 'string' ? data.author_name.trim() : '' }))
        .catch(() => null).finally(() => clearTimeout(timer));
      metadataRequests.set(videoId, request);
      return request;
    };
    let youtubePromise;
    const loadYouTube = () => {
      if (window.YT?.Player) return Promise.resolve(window.YT);
      if (youtubePromise) return youtubePromise;
      youtubePromise = new Promise((resolve, reject) => {
        const previous = window.onYouTubeIframeAPIReady;
        const timer = setTimeout(() => reject(new Error('YouTube API timeout')), 15000);
        window.onYouTubeIframeAPIReady = () => {
          clearTimeout(timer);
          resolve(window.YT);
          if (typeof previous === 'function') previous();
        };
        let script = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
        if (!script) {
          script = document.createElement('script');
          script.src = 'https://www.youtube.com/iframe_api';
          script.async = true;
          document.head.append(script);
        }
        script.addEventListener('error', () => {
          clearTimeout(timer);
          script.remove();
          reject(new Error('YouTube API unavailable'));
        }, { once: true });
      }).catch(error => { youtubePromise = null; throw error; });
      return youtubePromise;
    };
    customElements.define('fotric-video-hub', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.cards = Array.from(this.querySelectorAll('[data-fvh-grid] [data-fvh-card]'));
        this.category = 'all';
        this.model = '';
        this.mediaQuery = matchMedia('(max-width: 749px)');
        this.page = 1;
        this.modelSelect = this.querySelector('[data-fvh-model]');
        this.dialog = this.querySelector('[data-fvh-dialog]');
        this.detail = this.querySelector('[data-fvh-dialog-detail]');
        this.player = this.querySelector('[data-fvh-player]');
        this.querySelector('[data-fvh-filters]')?.removeAttribute('hidden');
        this.querySelectorAll('[data-fvh-thumbnail]').forEach(image => {
          const fallback = () => {
            if (!image.dataset.fvhFallback) return;
            const url = image.dataset.fvhFallback;
            delete image.dataset.fvhFallback;
            image.src = url;
          };
          image.addEventListener('error', fallback, { signal });
          image.addEventListener('load', () => { if (image.naturalWidth <= 120) fallback(); }, { signal });
          if (image.complete && image.naturalWidth <= 120) fallback();
        });
        this.updateModels();
        this.applyFilters();
        this.refreshMetadata();
        this.addEventListener('click', event => this.handleClick(event), { signal });
        this.addEventListener('change', event => {
          if (event.target.matches('[data-fvh-model]')) {
            this.model = event.target.value;
            this.page = 1;
            this.applyFilters();
          }
        }, { signal });
        this.dialog.addEventListener('close', () => this.cleanPlayer(), { signal });
        this.mediaQuery.addEventListener('change', () => {
          this.page = 1;
          this.applyFilters();
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const card = Array.from(this.querySelectorAll('[data-fvh-card]')).find(item => item.dataset.blockId === event.detail.blockId);
          if (!card) return;
          this.resetFilters();
          this.page = Math.max(1, Math.floor(this.cards.indexOf(card) / this.batchSize()) + 1);
          this.applyFilters();
          card.scrollIntoView({ block: 'center', behavior: 'auto' });
        }, { signal });
      }
      disconnectedCallback() {
        this.dialog?.close();
        this.cleanPlayer();
        this.controller?.abort();
        this.controller = null;
        this.metadataRunning = false;
      }
      refreshMetadata() {
        if (!this.controller || this.metadataRunning) return;
        const lifecycle = this.controller;
        const candidates = Array.from(this.querySelectorAll('[data-fvh-card]')).filter(card => !card.hidden && !card.dataset.metadataRequested && (card.dataset.autoTitle === 'true' || card.dataset.autoCreator === 'true'));
        if (!candidates.length) return;
        this.metadataRunning = true;
        candidates.forEach(card => { card.dataset.metadataRequested = 'true'; });
        const queue = candidates.slice();
        const worker = async () => {
          while (queue.length && !lifecycle.signal.aborted) {
            const card = queue.shift();
            if (!/^[a-zA-Z0-9_-]{11}$/.test(card.dataset.video)) continue;
            const data = await fetchMetadata(card.dataset.video);
            if (lifecycle.signal.aborted) return;
            if (data) this.applyMetadata(card, data);
          }
        };
        Promise.all([worker(), worker(), worker()]).finally(() => {
          if (this.controller !== lifecycle) return;
          this.metadataRunning = false;
          this.refreshMetadata();
        });
      }
      applyMetadata(card, data) {
        if (card.dataset.autoTitle === 'true' && data.title) card.dataset.reviewTitle = data.title;
        if (card.dataset.autoCreator === 'true' && data.creator) card.dataset.reviewCreator = data.creator;
        const title = card.dataset.reviewTitle;
        const creator = card.dataset.reviewCreator;
        const update = root => {
          if (title) root.querySelectorAll('[data-fvh-title]').forEach(node => { node.textContent = title; });
          if (creator) {
            root.querySelectorAll('[data-fvh-creator]').forEach(node => { node.textContent = creator; });
            root.querySelectorAll('[data-fvh-creator-row], [data-fvh-creator-container]').forEach(node => { node.hidden = false; });
            root.querySelectorAll('[data-fvh-avatar]').forEach(node => { node.textContent = creator.slice(0, 1).toUpperCase(); node.hidden = false; });
          }
          root.querySelectorAll('[data-fvh-dialog-meta]').forEach(node => {
            node.textContent = [creator, node.dataset.extraMeta].filter(Boolean).join(' · ');
            node.hidden = !node.textContent;
          });
        };
        update(card);
        update(card.querySelector('[data-fvh-detail]').content);
        if (title) {
          card.querySelector('.fvh-media').setAttribute('aria-label', this.dataset.watchLabel.replace('[title]', title));
          card.querySelector('.fvh-cover')?.setAttribute('alt', title);
        }
        if (this.activeCard === card && this.dialog.open) {
          update(this.detail);
          this.videoTitle = title;
          this.player.querySelector('iframe')?.setAttribute('title', title);
        }
      }
      batchSize() {
        return Number(this.mediaQuery.matches ? this.dataset.mobileCount : this.dataset.desktopCount) || 4;
      }
      inCategory(card) {
        return this.category === 'all' || card.dataset.categories.trim().split(/\s+/).includes(this.category);
      }
      updateModels() {
        if (!this.modelSelect) return;
        const models = [...new Set(this.cards.filter(card => this.inCategory(card)).map(card => card.dataset.model).filter(Boolean))];
        while (this.modelSelect.options.length > 1) this.modelSelect.remove(1);
        models.forEach(model => this.modelSelect.add(new Option(model, model)));
        if (!models.includes(this.model)) this.model = '';
        this.modelSelect.value = this.model;
        const buttons = this.querySelector('[data-fvh-model-buttons]');
        if (buttons) {
          buttons.replaceChildren();
          [['', this.modelSelect.options[0].textContent], ...models.map(model => [model, model])].forEach(([value, label]) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.dataset.fvhModelButton = value;
            button.textContent = label;
            button.setAttribute('aria-pressed', String(value === this.model));
            buttons.append(button);
          });
        }
      }
      applyFilters() {
        if (!this.cards.length) return;
        const matches = this.cards.filter(card => this.inCategory(card) && (!this.model || card.dataset.model === this.model));
        const pageSize = this.batchSize();
        const totalPages = Math.ceil(matches.length / pageSize);
        this.page = Math.min(Math.max(1, this.page), Math.max(1, totalPages));
        const offset = (this.page - 1) * pageSize;
        const visible = new Set(matches.slice(offset, offset + pageSize));
        this.cards.forEach(card => { card.hidden = !visible.has(card); });
        this.querySelectorAll('[data-fvh-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fvhCategory === this.category)));
        this.querySelector('[data-fvh-empty]').hidden = matches.length !== 0;
        this.querySelector('[data-fvh-grid]').hidden = matches.length === 0;
        this.renderPagination(totalPages);
        this.querySelector('[data-fvh-count]').textContent = this.dataset.countLabel.replace('[start]', String(matches.length ? offset + 1 : 0)).replace('[end]', String(offset + visible.size)).replace('[total]', String(matches.length));
        this.querySelector('.fvh-filter-secondary [data-fvh-reset]').hidden = this.category === 'all' && !this.model;
        this.querySelectorAll('[data-fvh-model-button]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fvhModelButton === this.model)));
        this.refreshMetadata();
      }
      renderPagination(totalPages) {
        const nav = this.querySelector('[data-fvh-pagination]');
        if (!nav) return;
        nav.replaceChildren();
        nav.hidden = totalPages <= 1;
        if (nav.hidden) return;
        const add = (label, page, disabled, numbered = false) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'fvh-page-button';
          button.dataset.fvhPage = String(page);
          button.textContent = label;
          button.disabled = disabled;
          if (numbered) {
            button.classList.add('fvh-page-number');
            button.setAttribute('aria-label', nav.dataset.pageLabel.replace('[page]', String(page)));
            if (page === this.page) button.setAttribute('aria-current', 'page');
          }
          nav.append(button);
        };
        add(nav.dataset.prev, this.page - 1, this.page === 1);
        const pages = totalPages <= 5 ? Array.from({ length: totalPages }, (_, i) => i + 1) :
          [...new Set([1, this.page - 1, this.page, this.page + 1, totalPages])].filter(p => p >= 1 && p <= totalPages).sort((a, b) => a - b);
        let previous = 0;
        pages.forEach(page => {
          if (previous && page - previous > 1) {
            const dots = document.createElement('span');
            dots.className = 'fvh-page-gap';
            dots.textContent = '…';
            dots.setAttribute('aria-hidden', 'true');
            nav.append(dots);
          }
          add(String(page), page, false, true);
          previous = page;
        });
        add(nav.dataset.next, this.page + 1, this.page === totalPages);
      }
      resetFilters() {
        this.category = 'all';
        this.model = '';
        this.page = 1;
        this.updateModels();
        this.applyFilters();
      }
      handleClick(event) {
        const target = event.target.closest('button, a');
        if (target?.hasAttribute('data-fvh-open')) {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const card = target.closest('[data-fvh-card]');
          if (!/^[a-zA-Z0-9_-]{11}$/.test(card.dataset.video) || !this.dialog.showModal) return;
          event.preventDefault();
          this.openVideo(card, target);
        } else if (target?.hasAttribute('data-fvh-model-button')) {
          this.model = target.dataset.fvhModelButton;
          this.modelSelect.value = this.model;
          this.page = 1;
          this.applyFilters();
        } else if (target?.hasAttribute('data-fvh-category')) {
          this.category = target.dataset.fvhCategory;
          this.page = 1;
          this.updateModels();
          this.applyFilters();
        } else if (target?.hasAttribute('data-fvh-reset')) {
          this.resetFilters();
        } else if (target?.hasAttribute('data-fvh-page')) {
          if (target.disabled) return;
          const nextPage = Number(target.dataset.fvhPage);
          if (!Number.isInteger(nextPage) || nextPage === this.page) return;
          this.page = nextPage;
          this.applyFilters();
          const heading = this.querySelector('.fvh-library-heading');
          heading?.focus({ preventScroll: true });
          heading?.scrollIntoView({ block: 'start', behavior: 'auto' });
        } else if (target?.hasAttribute('data-fvh-close')) {
          this.dialog.close();
        } else if (target?.hasAttribute('data-fvh-seek')) {
          this.seekPlayer(Number(target.dataset.fvhSeek));
          this.detail.querySelectorAll('[data-fvh-seek]').forEach(button => button.setAttribute('aria-pressed', String(button === target)));
          if (matchMedia('(max-width: 899px)').matches) this.dialog.scrollTo({ top: 0, behavior: 'auto' });
        }
        if (event.target === this.dialog) {
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }
      }
      openVideo(card, trigger) {
        this.trigger = trigger;
        this.activeCard = card;
        this.videoId = card.dataset.video;
        this.videoTitle = card.querySelector('.fvh-title').textContent.trim();
        this.detail.replaceChildren(card.querySelector('[data-fvh-detail]').content.cloneNode(true));
        this.detail.querySelector('[data-fvh-dialog-title]').id = 'FvhDialogTitle-' + this.dataset.sectionId;
        this.loadPlayer(0);
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.bodyLocked = true;
        this.dialog.showModal();
        this.dialog.scrollTop = 0;
      }
      loadPlayer(seconds) {
        const generation = this.playerGeneration = (this.playerGeneration || 0) + 1;
        this.playerReady = false;
        this.playerFailed = false;
        this.pendingSeek = null;
        this.playerStatus = this.querySelector('[data-fvh-player-status]');
        this.playerStatus.textContent = '';
        const iframe = document.createElement('iframe');
        iframe.id = 'FvhPlayer-' + this.dataset.sectionId;
        iframe.title = this.videoTitle;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        const params = new URLSearchParams({ autoplay: '1', rel: '0', playsinline: '1', enablejsapi: '1', origin: location.origin, start: String(Math.max(0, Math.floor(seconds || 0))) });
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + this.videoId + '?' + params;
        this.player.replaceChildren(iframe);
        loadYouTube().then(YT => {
          if (this.playerGeneration !== generation || !this.isConnected || !this.dialog.open) return;
          this.youtube = new YT.Player(iframe, { events: {
            onReady: event => {
              if (this.playerGeneration !== generation) return;
              this.playerReady = true;
              this.playerStatus.textContent = '';
              if (this.pendingSeek !== null) {
                event.target.seekTo(this.pendingSeek, true);
                this.pendingSeek = null;
              }
              event.target.playVideo();
            },
            onStateChange: event => {
              if (this.playerGeneration === generation && event.data === 1) this.playerStatus.textContent = '';
            },
            onAutoplayBlocked: () => {
              if (this.playerGeneration === generation) this.playerStatus.textContent = this.dataset.playBlocked;
            },
            onError: () => {
              if (this.playerGeneration === generation) {
                this.playerFailed = true;
                this.playerStatus.textContent = this.dataset.playerError;
              }
            }
          }});
        }).catch(() => {
          if (this.playerGeneration === generation) {
            this.playerFailed = true;
            this.playerStatus.textContent = this.dataset.playerError;
          }
        });
      }
      seekPlayer(seconds) {
        const time = Math.max(0, Math.floor(Number(seconds) || 0));
        const fallback = this.detail.querySelector('.fvh-youtube-link');
        if (fallback) fallback.href = 'https://www.youtube.com/watch?v=' + this.videoId + '&t=' + time + 's';
        if (this.playerFailed) {
          this.playerStatus.textContent = this.dataset.playerError;
        } else if (this.playerReady && this.youtube) {
          this.youtube.seekTo(time, true);
          this.youtube.playVideo();
          this.playerStatus.textContent = '';
        } else {
          this.pendingSeek = time;
          this.playerStatus.textContent = this.dataset.playerLoading;
        }
      }
      cleanPlayer() {
        this.playerGeneration = (this.playerGeneration || 0) + 1;
        this.playerReady = false;
        this.pendingSeek = null;
        try { this.youtube?.destroy(); } catch (_) {}
        this.youtube = null;
        this.player?.replaceChildren();
        if (this.bodyLocked) {
          document.body.style.overflow = this.previousOverflow;
          this.bodyLocked = false;
        }
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
        this.trigger = null;
        this.activeCard = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerInner = document.querySelector('.header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		
		if (this.headerIsAlwaysSticky) this.reveal; 
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_carsoul"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      const sections = root.matches?.('[data-premium-products]')
        ? [root]
        : Array.from(root.querySelectorAll?.('[data-premium-products]') || []);

      sections.forEach((section) => {
        if (section.dataset.carouselReady === 'true') return;

        const track = section.querySelector('[data-track]');
        const cards = Array.from(section.querySelectorAll('[data-card]'));
        const previous = section.querySelector('[data-previous]');
        const next = section.querySelector('[data-next]');
        const counter = section.querySelector('[data-counter]');
        const progress = section.querySelector('[data-progress]');

        if (!track || cards.length === 0) return;

        section.dataset.carouselReady = 'true';

        let currentIndex = 0;
        let maximumIndex = 0;
        let frame = 0;
        const twoDigits = (number) => String(number).padStart(2, '0');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const getStep = () => {
          if (cards.length < 2) return cards[0].getBoundingClientRect().width;
          return Math.abs(cards[1].offsetLeft - cards[0].offsetLeft);
        };

        const calculateMaximumIndex = () => {
          const step = getStep();
          if (!step) return 0;
          return Math.max(0, Math.ceil((track.scrollWidth - track.clientWidth) / step));
        };

        const render = () => {
          const step = getStep();
          maximumIndex = calculateMaximumIndex();
          currentIndex = step ? Math.round(track.scrollLeft / step) : 0;
          currentIndex = Math.max(0, Math.min(currentIndex, maximumIndex));

          const totalPositions = maximumIndex + 1;
          if (counter) counter.textContent = `${twoDigits(currentIndex + 1)} / ${twoDigits(totalPositions)}`;
          if (progress) {
            const ratio = maximumIndex === 0 ? 1 : (currentIndex + 1) / (maximumIndex + 1);
            progress.style.transform = `scaleX(${ratio})`;
          }

          if (previous) previous.disabled = currentIndex <= 0;
          if (next) next.disabled = currentIndex >= maximumIndex;
          section.classList.toggle('premium-products--static', maximumIndex === 0);
        };

        const scheduleRender = () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(render);
        };

        const goTo = (index) => {
          maximumIndex = calculateMaximumIndex();
          const targetIndex = Math.max(0, Math.min(index, maximumIndex));
          const card = cards[targetIndex];
          if (!card) return;
          const targetLeft = track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left;
          track.scrollTo({ left: targetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        };

        previous?.addEventListener('click', () => goTo(currentIndex - 1));
        next?.addEventListener('click', () => goTo(currentIndex + 1));

        track.addEventListener('scroll', scheduleRender, { passive: true });
        track.addEventListener('keydown', (event) => {
          if (event.target !== track) return;

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            goTo(currentIndex - 1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            goTo(currentIndex + 1);
          }
        });

        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(scheduleRender);
          observer.observe(track);
        }

        render();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recent_view"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fotric-explore-more')) {
    customElements.define('fotric-explore-more', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.fer__track');
        if (!this.track) return;
        this.controls = this.querySelector('.fer__controls');
        this.previous = this.querySelector('.fer__previous');
        this.next = this.querySelector('.fer__next');
        this.update = () => {
          const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const offset = Math.min(max, Math.abs(this.track.scrollLeft));
          this.controls.hidden = max < 2;
          this.previous.disabled = offset < 2;
          this.next.disabled = offset >= max - 2;
        };
        this.move = (direction) => {
          const first = this.track.querySelector('.fer__item');
          if (!first) return;
          const styles = getComputedStyle(this.track);
          const step = first.getBoundingClientRect().width + (parseFloat(styles.columnGap) || 0);
          const sign = styles.direction === 'rtl' ? -1 : 1;
          this.track.scrollBy({left: direction * sign * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        };
        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.onSelect = (event) => {
          const item = event.target.closest('.fer__item');
          if (!item || !this.track.contains(item)) return;
          const itemRect = item.getBoundingClientRect();
          const trackRect = this.track.getBoundingClientRect();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          this.track.scrollBy({left: rtl ? itemRect.right - trackRect.right : itemRect.left - trackRect.left, behavior: 'auto'});
        };
        this.previous.addEventListener('click', this.onPrevious);
        this.next.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.update, {passive:true});
        this.addEventListener('shopify:block:select', this.onSelect);
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.frame = requestAnimationFrame(this.update);
      }
      disconnectedCallback() {
        if (!this.track) return;
        this.previous.removeEventListener('click', this.onPrevious);
        this.next.removeEventListener('click', this.onNext);
        this.track.removeEventListener('scroll', this.update);
        this.removeEventListener('shopify:block:select', this.onSelect);
        this.observer.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fotric-testimonials')) {
    customElements.define('fotric-testimonials', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.controller = new AbortController();
        this.viewport = this.querySelector('[data-viewport]');
        this.track = this.querySelector('[data-track]');
        this.originalSlides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.previousButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.currentDisplay = this.querySelector('[data-current]');
        this.currentIndex = 0;
        this.frame = null;
        this.wrapTimer = null;
        this.dragState = null;

        if (!this.viewport || !this.track || this.originalSlides.length === 0) return;

        this.prepareSlides();
        this.bindEvents();
        this.resizeObserver = new ResizeObserver(() => this.goTo(this.currentIndex, false));
        this.resizeObserver.observe(this.viewport);

        requestAnimationFrame(() => this.goTo(0, false));
      }

      prepareSlides() {
        this.originalSlides.forEach((slide, index) => {
          slide.dataset.index = String(index);
          slide.dataset.carouselItem = '';
        });

        if (this.originalSlides.length > 1) {
          const firstClone = this.createClone(this.originalSlides[0], 0);
          const lastIndex = this.originalSlides.length - 1;
          const lastClone = this.createClone(this.originalSlides[lastIndex], lastIndex);

          this.track.prepend(lastClone);
          this.track.append(firstClone);
        }

        this.items = Array.from(this.track.querySelectorAll('[data-carousel-item]'));
      }

      createClone(source, index) {
        const clone = source.cloneNode(true);
        const elements = [clone, ...clone.querySelectorAll('*')];

        clone.removeAttribute('data-slide');
        clone.setAttribute('data-clone', '');
        clone.setAttribute('data-carousel-item', '');
        clone.setAttribute('data-index', String(index));
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('aria-current');

        elements.forEach((element) => {
          element.removeAttribute('id');

          Array.from(element.attributes).forEach((attribute) => {
            if (attribute.name.startsWith('data-shopify')) {
              element.removeAttribute(attribute.name);
            }
          });
        });

        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });

        return clone;
      }

      bindEvents() {
        const signal = this.controller.signal;

        this.previousButton?.addEventListener('click', () => {
          this.goTo(this.currentIndex - 1);
        }, { signal });

        this.nextButton?.addEventListener('click', () => {
          this.goTo(this.currentIndex + 1);
        }, { signal });

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this.goTo(Number(dot.dataset.index));
          }, { signal });
        });

        this.querySelectorAll('[data-review-toggle]').forEach((button) => {
          if (button.closest('[data-clone]')) return;

          button.addEventListener('click', () => {
            const slide = button.closest('[data-slide]');
            const isExpanded = slide.classList.toggle('is-expanded');

            button.setAttribute('aria-expanded', String(isExpanded));
            button.textContent = isExpanded ? button.dataset.lessLabel : button.dataset.moreLabel;

            requestAnimationFrame(() => this.goTo(this.currentIndex, false));
          }, { signal });
        });

        this.viewport.addEventListener('scroll', () => {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateFromScroll());
        }, { passive: true, signal });

        this.viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.currentIndex - 1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.currentIndex + 1);
          }
        }, { signal });

        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          if (event.target.closest('a, button')) return;

          this.dragState = {
            id: event.pointerId,
            startX: event.clientX,
            startScrollLeft: this.viewport.scrollLeft
          };
          this.viewport.setPointerCapture(event.pointerId);
          this.viewport.classList.add('is-dragging');
        }, { signal });

        this.viewport.addEventListener('pointermove', (event) => {
          if (!this.dragState || event.pointerId !== this.dragState.id) return;

          const movement = event.clientX - this.dragState.startX;
          this.viewport.scrollLeft = this.dragState.startScrollLeft - movement;
        }, { signal });

        const finishDrag = (event) => {
          if (!this.dragState || event.pointerId !== this.dragState.id) return;

          if (this.viewport.hasPointerCapture(event.pointerId)) {
            this.viewport.releasePointerCapture(event.pointerId);
          }

          this.dragState = null;
          this.viewport.classList.remove('is-dragging');
          this.updateFromScroll();
          this.goTo(this.currentIndex);
        };

        this.viewport.addEventListener('pointerup', finishDrag, { signal });
        this.viewport.addEventListener('pointercancel', finishDrag, { signal });

        document.addEventListener('shopify:block:select', (event) => {
          if (!(event.target instanceof Element) || !this.contains(event.target)) return;

          const slide = event.target.closest('[data-slide]');
          if (slide) this.goTo(Number(slide.dataset.index), false);
        }, { signal });
      }

      goTo(index, smooth = true) {
        const count = this.originalSlides.length;
        const normalizedIndex = (index + count) % count;
        let target = this.originalSlides[normalizedIndex];
        let wrapTarget = null;

        if (count > 1 && index < 0 && this.currentIndex === 0) {
          target = this.items[0];
          wrapTarget = this.originalSlides[count - 1];
        }

        if (count > 1 && index >= count && this.currentIndex === count - 1) {
          target = this.items[this.items.length - 1];
          wrapTarget = this.originalSlides[0];
        }

        if (!target) return;

        this.currentIndex = normalizedIndex;
        this.setActiveState(normalizedIndex);
        this.scrollToItem(target, smooth);

        if (wrapTarget) {
          clearTimeout(this.wrapTimer);
          this.wrapTimer = setTimeout(() => this.scrollToItem(wrapTarget, false), 520);
        }
      }

      scrollToItem(item, smooth) {
        const left = item.offsetLeft - ((this.viewport.clientWidth - item.offsetWidth) / 2);
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.viewport.scrollTo({
          left,
          behavior: smooth && !reducedMotion ? 'smooth' : 'auto'
        });
      }

      updateFromScroll() {
        this.frame = null;
        const center = this.viewport.scrollLeft + (this.viewport.clientWidth / 2);
        let closestItem = this.items[0];
        let closestDistance = Number.POSITIVE_INFINITY;

        this.items.forEach((item) => {
          const itemCenter = item.offsetLeft + (item.offsetWidth / 2);
          const distance = Math.abs(center - itemCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestItem = item;
          }
        });

        const closestIndex = Number(closestItem.dataset.index);

        if (closestIndex !== this.currentIndex) {
          this.currentIndex = closestIndex;
          this.setActiveState(closestIndex);
        }

        if (closestItem.hasAttribute('data-clone') && !this.dragState) {
          const matchingSlide = this.originalSlides[closestIndex];
          clearTimeout(this.wrapTimer);
          this.wrapTimer = setTimeout(() => this.scrollToItem(matchingSlide, false), 140);
        }
      }

      setActiveState(index) {
        this.items.forEach((slide) => {
          const isActive = Number(slide.dataset.index) === index;
          slide.classList.toggle('is-active', isActive);

          if (!slide.hasAttribute('data-clone')) {
            slide.setAttribute('aria-current', String(isActive));
          }
        });

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', String(isActive));
        });

        if (this.currentDisplay) {
          this.currentDisplay.textContent = String(index + 1).padStart(2, '0');
        }
      }

      disconnectedCallback() {
        if (this.frame) cancelAnimationFrame(this.frame);
        clearTimeout(this.wrapTimer);
        this.resizeObserver?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
